import React, {Component, useEffect, useMemo, useState} from "react";
import NotificationManager from "react-notifications/lib/NotificationManager";
import {AgGridReact} from "ag-grid-react";
import {
    ColumnMenuModule,
    ColumnsToolPanelModule,
    ContextMenuModule,
    MasterDetailModule,
    MultiFilterModule,
    ServerSideRowModelModule,
    SetFilterModule,
} from "ag-grid-enterprise";
import {AllCommunityModule, ClientSideRowModelModule} from "ag-grid-community";
import {Helmet} from "react-helmet";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    checkIncidentHasRelatedProcessInjectionsAndCreationsReactive,
    createSilentIncidentsFromIncidentsPageReactive,
    deleteIncidentProgramReactive,
    findSilentIncidentNamesForSingleIncidentIdReactive,
    findSuggestedPathsReactive,
    findSuggestedSilentIncidentPathsReactive,
    getCCDiffFileReactive,
    getDetailRowsForIncidentTimeSeriesReactive, getDLLPathForDataIncidentReactive,
    incidentsPerGroupCountReactive, incidentTimeSeriesFullListReactive,
    incidentTimeSeriesListReactive,
    submitIncidentForReviewReactive,
    updateDataIncidentChartVisibilityReactive,
    updateIncidentsGridColumnModeReactive,
    updateIncidentsGridColumnStateReactive,
    updateIncidentsGridFilterModelReactive,
    updateIncidentsGridUseColumnStateReactive,
    updateIncidentsGridUseFilterStateReactive,
    userAddWhitelistsFromIncidentsPageReactive,
    userSetIncidentAsNotSilentReactive,
    updateFullIncidentGridEnabledReactive,
} from "../api/incidentsApi";
import Modal from "react-modal";
import {findBySingleWhitelistAppliedIdReactive} from "../api/tailoredBehaviorsApi";
import {useForm} from "react-hook-form";
import {defaultZenGroupColumnInitWithOptionsWithValueGetter} from "../../utils/zenGroupDisplayNameGridHelper";
import {defaultAgentNameColumnInitWithOptions} from "../../utils/agentNameGridHelper";
import {dateValueFormatter} from "../../utils/gridDateFormatter";
import {incidentPageCellEditingStopped} from "../../utils/gridCellEditing";
import {AgChartsReact} from "ag-charts-react";
import {agentVersionFormatter} from "../../utils/agentVersionFormatter";
import {Link, useLocation, useOutletContext} from "react-router-dom"
import {findZenGroupById, useZenGroupSessionStorage} from "../../utils/zenGroupSessionStorageManager";
import {masterFilterHelper, serverSideFilterHelperHandleMultiConditionChecks} from "../../utils/filterHelper";
import {
    dataIncidentChartVisibleSessionVariable,
    dataIncidentFullGridEnabledSessionVariable,
    getChartVisibilitySettingInSession,
    getColumnModeInSession,
    getDefaultAgGridSidebarProps,
    getUseColumnStateInSession,
    getUseFilterStateInSession,
    onColumnStateChangedHelper,
    onFilterChangedHelper,
    onGridReadyHelper,
    onGridReadyHelperForColumnStateForIncidentsGrid,
    updateChartVisibilitySettingInSession,
    updateColumnModeInSessionHelper,
    updateUseColumnStateHelper,
    updateUseFilterStateHelper
} from "../../utils/gridFilterStateAndColumnStateHelper";
import {ClearRefresh} from "../../components/clearRefreshButtons";
import {
    incidentNameCellRendererFrameworkForIncidentsGrid,
    removePathFromStartOfProgramArgumentsHelper
} from "../../utils/incidentNameGridHelper";
import CustomNameCellEditor from "../../utils/customCellEditor";
import DTPicker, {dateFilterParametersInHeaderSuppressSorting} from "../../utils/DTPicker";
import {GridColumnFilterStateSaving} from "../../components/columnfilterComponent";
import {base64DecodedValueFormatter} from "../../utils/gridBase64ValueFormatter";
import privatePageHeaderHelper from "../../utils/privatePageHeaderHelper";
import {getAgentFriendlyNamesReactive} from "../api/licensesApi";
import {BackDropChartLoadingOverlay} from "../../components/BackDropComponents";
import {buttonTheme, roundButtonTheme, switchTheme} from "../../utils/muiStyling";
import {Button, FormControlLabel, Switch, ThemeProvider} from "@mui/material";
import {
    MuiAutocompleteNonGroupOptions,
    MuiCloseIconButton,
    MuiIconButtonWithTooltip,
    MuiIconWithTooltip
} from "../../components/muiComponents";
import {
    ClickToShowColumnOptionsWithToggleButtonGroup,
    customColumnModeText,
    mediumColumnModeText,
    minColumnModeText,
    standardApplyMinimumOrMediumColumnMode
} from "../../components/clickToShowButtons";
import TimerOffOutlinedIcon from "@mui/icons-material/TimerOffOutlined";
import VpnKeyOffOutlinedIcon from "@mui/icons-material/VpnKeyOffOutlined";
import {findNotificationEventForDataIncidentAutoFilter} from "../api/notificationEventApi";
import {
    checkIsUsingRememberMe,
    decryptAndGetSessionVariable,
    encryptAndStoreSessionVariable
} from "../../utils/storageHelper";
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import {InformationModal} from "../../components/informationOnlyModal";
import {BrowserUtilityProcessTuningModal} from "../../components/responseTuningComponents";
import {fileTriggersToMatchAllOptions, handleFileTriggerTypesSelectedForCreateWhitelist} from "./tailoredBehaviors";
import {ConfirmationModal} from "../../components/confirmationModal";
import {formatDayOrMonthWithLeadingZero} from "./licenses";
import {DisplayOptions} from "../../components/displayOptionsComponent";

let gridColumnStateSessionVariableName = "incidentsGridColumnState"
let fullGridColumnStateSessionVariableName = "extortionResponseFullGridColumnState"
let fullGridEnabledSessionVariableName = dataIncidentFullGridEnabledSessionVariable
let fileAttributesString = "File Attributes"
let chartSessionVariableName = dataIncidentChartVisibleSessionVariable
//Note that these lists are used for both grids. incidentDisplayName and collected are included for the full grid, this has no effect on parent/child grid since it does not have these columns so we could add more if we want to
let minColumnIds = ["incidentsCount", "zenGroupDisplayName", "incidentDisplayName", "machineName", "pathEncoded", "dateCreatedRounded", "collected", "whitelistAppliedId"]
let medColumnIds = ["incidentsCount", "zenGroupDisplayName", "incidentDisplayName", "machineName", "pathEncoded", "programArgumentsEncoded", "parentPathEncoded", "dateCreatedRounded", "collected", "whitelistAppliedId"]
let chromeUtilityArgsToShowTuningModal = [
    "--type=utility --utility-sub-type=chrome.mojom.UtilWin",
    "--type=utility --utility-sub-type=data_decoder.mojom",
    "--type=utility --utility-sub-type=quarantine.mojom.Quarantine",
    "--type=utility --utility-sub-type=chrome.mojom.DocumentAnalysisService",
    "--type=utility --utility-sub-type=patch.mojom.FilePatcher",
    "--type=utility --utility-sub-type=storage.mojom.StorageService",
    "--type=utility --utility-sub-type=network.mojom.NetworkService",
    "--type=utility --utility-sub-type=media.mojom.SpeechRecognitionService",
    "--type=utility --utility-sub-type=audio.mojom.AudioService",
    "--type=utility --utility-sub-type=chrome.mojom.ProcessorMetrics",
    "--type=utility --utility-sub-type=unzip.mojom.Unzipper",
    "--type=utility --utility-sub-type=video_capture.mojom.VideoCaptureService",
    "--type=utility --utility-sub-type=proxy_resolver.mojom.ProxyResolverFactory",
    "--type=utility --utility-sub-type=printing.mojom.PrintingService",
    "--type=utility --utility-sub-type=printing.mojom.PrintCompositor",
    "--type=utility --utility-sub-type=edge_collections.mojom.CollectionsDataManager",
    "--type=utility --utility-sub-type=device.mojom.XRDeviceService",
    "--type=utility --utility-sub-type=media.mojom.MediaFoundationServiceBroker",
    "--type=utility --utility-sub-type=chrome.mojom.FileUtilService",
    "--type=utility --utility-sub-type=media.mojom.CdmServiceBroker",
    "--type=utility --utility-sub-type=auction_worklet.mojom.AuctionWorkletService",
    "--type=utility --utility-sub-type=on_device_model.mojom.OnDeviceModelService",
    "--type=utility --utility-sub-type=screen_ai.mojom.ScreenAIServiceFactory",
    "--type=utility --utility-sub-type=printing.mojom.UnsandboxedPrintBackendHost"
]
const processData = (data, forWhitelistModal=false) => {
    let memString = ""
    const memVal = data.memory
    memString = memVal;
    if (memVal > 1000) {
        memString = (memVal / 1000).toFixed(2) + " KB"
    }
    if (memVal > 1000000) {
        memString = (memVal / 1000000).toFixed(2) + " MB"
    }
    if (memVal > 1000000000) {
        memString = (memVal / 1000000000).toFixed(2) + " GB"
    }
    if(data.lastResponseTimestamp){
        data.lastResponseTimestamp = new Date(data.lastResponseTimestamp).toUTCString()
    }

    let programArgumentsString = ""
    let parentProgramArgumentsString = ""

    if(data) {
        programArgumentsString = removePathFromStartOfProgramArgumentsHelper(data.path, data.programArguments)
        parentProgramArgumentsString = removePathFromStartOfProgramArgumentsHelper(data.parentPath, data.parentProgramArguments)
    }

    data.programArgumentsEditedString = programArgumentsString
    data.parentProgramArgumentsString = parentProgramArgumentsString
    let gridData
    if(forWhitelistModal){
        //for whitelist modal, don't need to include all fields
        gridData = {
            "Response Name": data.incidentDisplayName,
            "Program Path": data.path,
            "Program Arguments": programArgumentsString,
            "Parent Program Path": data.parentPath,
            "Parent Program Arguments": parentProgramArgumentsString
        };
    }
    else{
        //else for details modal, include additional fields
        let pidReuse = ""
        let bootGuid = ""
        if(data.uniqueProcessIdentifier !== null && data.uniqueProcessIdentifier !== undefined){
            pidReuse = data.uniqueProcessIdentifier.reuseCount
            bootGuid = data.uniqueProcessIdentifier.bootGuid
        }
        gridData = {
            "Response Name": data.incidentDisplayName,
            "Machine Name": data.machineName,
            "Program Path": data.path,
            "Program Arguments": programArgumentsString,
            "Program File Hash": data.fileHash,
            "Parent Program Path": data.parentPath,
            "Parent Program Arguments": parentProgramArgumentsString,
            "Data Access Attempted": handleCanaryPath(data.accessedFilePath),
            "Ram usage": memString,
            "Pid": data.pid,
            "Pid Reuse Number": pidReuse,
            "Process Execution GUID": bootGuid,
            "Username": data.username,
            "User SID": data.userSid,
        };
    }

    return Object.keys(gridData).map((key) => ({
        description: key,
        value: gridData[key],
    }))
};

let whitelistedFilterValueOptions = ['Excluded', 'Not Excluded']

export default function Incidents() {
    const { isLoading, setIsLoading } = useOutletContext();
    // eslint-disable-next-line no-unused-vars
    const [activeIncident, setActiveIncident] = useState();
    const [clickedIconIncidentData, setClickedIconIncidentData] = useState();
    const [showNoSuggestedPathsFoundIcon, setShowNoSuggestedPathsFoundIcon] = useState(false);
    const [showNoSuggestedSilentIncidentPathsFoundIcon, setShowNoSuggestedSilentIncidentPathsFoundIcon] = useState(false);
    const [openResponseHistoryModal, setOpenResponseHistoryModal] = useState();
    // eslint-disable-next-line no-unused-vars
    const [ignoreButtonDisabled, setIgnoreButtonDisabled] = useState(true);
    const [showIgnoreModal, setShowIgnoreModal] = useState(false);
    const [moreInformationModalOpen, setMoreInformationModalOpen] = useState(false);
    const [moreInfoModalText, setMoreInfoModalText] = useState(<div></div>);
    // eslint-disable-next-line no-unused-vars
    const { register, handleSubmit, errors, watch, reset } = useForm();
    const [gridApi, setGridApi] = useState(null);
    const [fullGridApi, setFullGridApi] = useState(null);
    const [suggestedPaths, setSuggestedPaths] = useState([]);
    const [selectedPaths, setSelectedPaths] = useState([]);
    const [ignoreSubmitButtonDisabled, setIgnoreSubmitButtonDisabled] = useState(false);
    const [whitelistModalIncludeProgramArgs, setWhitelistModalIncludeProgramArgs] = useState(false);
    const [whitelistModalIncludeParentPath, setWhitelistModalIncludeParentPath] = useState(false);
    const [whitelistModalIncludeParentProgramArgs, setWhitelistModalIncludeParentProgramArgs] = useState(false);
    const [newWhitelistIncidentMatchTypeList, setNewWhitelistIncidentMatchTypeList] = useState(fileTriggersToMatchAllOptions); //default to all
    const [temporaryWhitelistToggled, setTemporaryWhitelistToggled] = useState(false);
    const [hideCanariesToggled, setHideCanariesToggled] = useState(false);
    const [additionalRestrictionsToggled, setAdditionalRestrictionsToggled] = useState(false);
    const [onlyMatchIfTrustedCert, setOnlyMatchIfTrustedCert] = useState(false);
    const [onlyMatchIfNoInjections, setOnlyMatchIfNoInjections] = useState(false);
    const [onlyMatchIfNoModifiedMemory, setOnlyMatchIfNoModifiedMemory] = useState(false);
    const [silentIncidentTurnOnModalButtonDisabled, setSilentIncidentTurnOnModalButtonDisabled] = useState(false);
    const [showCertificateModal, setShowCertificateModal] = useState(false);
    const [showCertificateHashModal, setShowCertificateHashModal] = useState(false);
    const [chartDataWithoutWhitelistedCount, setChartDataWithoutWhitelistedCount] = useState([]);
    const [chartDataWithWhitelistedCount, setChartDataWithWhitelistedCount] = useState([]);
    const [chartIsLoading, setChartIsLoading] = useState(false);
    const [chartToggled, setChartToggled] = useState(getChartVisibilitySettingInSession(chartSessionVariableName));
    const [includeWhitelistedToggled, setIncludeWhitelistedToggled] = useState(false);
    const [includeWhitelistedToggleDisabled, setIncludeWhitelistedToggleDisabled] = useState(true);
    const [zenGroupForTuningModal, setZenGroupForTuningModal] = useState(null);
    // eslint-disable-next-line no-unused-vars
    const [zenGroupSessionStorage,setZenGroupSessionStorage] = useZenGroupSessionStorage()
    const [useFilterStateSettingToggled, setUseFilterStateSettingToggled] = useState(getUseFilterStateInSession("incidentsGridFilterState"));
    const [fullGridToggled, setFullGridToggled] = useState(getFullGridEnabledSessionState());
    const [showTurnIncidentSilentModal, setShowTurnIncidentSilentModal] = useState(false);
    const [tuningModalIsOpen, setTuningModalIsOpen] = useState(false);
    const [useColumnStateSettingToggled, setUseColumnStateSettingToggled] = useState(getUseColumnStateInSession(gridColumnStateSessionVariableName));
    const [detailRowHeight, setDetailRowHeight] = useState(500);
    const [columnMode, setColumnMode] = useState(getColumnModeInSession(gridColumnStateSessionVariableName));
    const [fullGridColumnMode, setFullGridColumnMode] = useState(getColumnModeInSession(fullGridColumnStateSessionVariableName));
    const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
    const [confirmDeleteModalIsOpen, setConfirmDeleteModalIsOpen] = useState(false);
    const [deleteModalRowData, setDeleteModalRowData] = useState(null);
    const incidentLocation = useLocation();

    // eslint-disable-next-line no-unused-vars
    const [parentChildInitialGridColumnDefs, setParentChildInitialGridColumnDefs] = useState([
        { field: "incidentsCount", headerName: "Number of Incidents", initialWidth: 250,
            cellRenderer: 'agGroupCellRenderer',
            filter: 'agNumberColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],

                filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual'],
                maxNumConditions: 2,
            },
            sortable: true,
            pinned: 'left',
            hide: false,
        },
        defaultZenGroupColumnInitWithOptionsWithValueGetter(true, true, true),
        defaultAgentNameColumnInitWithOptions(true, 5),
        { field: "machineName", headerName: "Machine Name", initialWidth: 225,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],

                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 5,
            },
            cellRenderer:function(params){
                let agentLinkDiv = ""
                if(params.data.agentId){
                    //only using agentId for cross-link filter now so only need to check agentId exists
                    agentLinkDiv =
                        <Link to={{pathname:"/private/agents"}} state={{agentDisplayNameClicked: params.node.data.agentDisplayName, zenGroupIdClicked: params.node.data.zenGroupId,
                            agentIdClicked : params.node.data.agentId, machineNameClicked: params.node.data.machineNameForLocationLink}} className="">
                            <MuiIconButtonWithTooltip
                                icon={
                                    <FontAwesomeIcon
                                        className="object-contain"
                                        icon="fa-duotone fa-user-gear"
                                        size="xs"
                                    />
                                }
                                tooltipTitle={"Click to Manage This Agent"}
                                tooltipPlacement={"bottom-start"}
                            />
                        </Link>
                }
                return(
                    <div className={"flex flex-nowrap items-center gap-x-2"}>
                        {agentLinkDiv}
                        {params.value}
                    </div>
                )
            },
            sortable: true,
        },
        { field: "pathEncoded", headerName: "Program Path", initialWidth: 600,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],

                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 2,
            },
            valueFormatter: base64DecodedValueFormatter,
            cellRenderer:function(params){
                let detailsDiv = ""
                //check for chrome path and args for the more info modal, check edgewebview as well
                if(params.valueFormatted && (params.valueFormatted.toLowerCase() === "C:\\Program Files\\Google\\Chrome\\Application\\chrome.exe".toLowerCase()
                    || params.valueFormatted.toLowerCase() === "C:\\Program Files (x86)\\Google\\Chrome\\Application\\chrome.exe".toLowerCase()
                    || /C:\\Program Files.*\\Microsoft\\EdgeWebView\\Application\\.+\\msedgewebview2\.exe/i.test(params.valueFormatted)
                )){
                    let validArgs = false
                    try{
                        let args = atob(params.data.programArgumentsEncoded).toLowerCase()
                        validArgs = checkChromeProgramArgumentsForTuningModal(args)
                    }
                    catch(error){}
                    if(validArgs){
                        detailsDiv = <MuiIconButtonWithTooltip
                            icon={
                                <FontAwesomeIcon className={`object-contain`} icon={"fa-duotone fa-music-note"} size="xs" color={`black`}/>
                            }
                            tooltipTitle={"Tuning Available"} tooltipPlacement={"bottom-start"}
                            onClick={() => {
                                if(params.node.data.zenGroupId){
                                    setZenGroupForTuningModal(params.node.data.zenGroupId)
                                }
                                else{
                                    setZenGroupForTuningModal(null)
                                }
                                setTuningModalIsOpen(true)
                            }}
                        />
                    }
                }
                else if(params.valueFormatted && params.valueFormatted.toLowerCase().trim() === "C:\\Windows\\System32\\WindowsPowerShell\\v1.0\\powershell.exe".toLowerCase()){ //check for powershell path and windows ccm program args
                    let validArgs = false
                    try{
                        let args = atob(params.data.programArgumentsEncoded).toLowerCase()
                        if(args.includes("-ExecutionPolicy Bypass \"& 'C:\\WINDOWS\\CCM\\SystemTemp\\".toLowerCase())){
                            validArgs = true
                        }
                    }
                    catch(error){}

                    let validParentPath = false
                    try{
                        let parentPath = atob(params.data.parentPathEncoded).toLowerCase()
                        if(parentPath && parentPath.trim() === "C:\\Windows\\System32\\wbem\\WmiPrvSE.exe".toLowerCase()){
                            validParentPath = true
                        }
                    } catch (e) {}
                    if(validArgs && validParentPath){
                        detailsDiv = <MuiIconButtonWithTooltip
                            icon={<PrivacyTipIcon color={"action"} className={"cursor-pointer"} />}
                            tooltipTitle={"More Info"}
                            tooltipPlacement={"top"}
                            onClick={() => {
                                let textDiv =
                                    <div className={"flex flex-col gap-y-3"}>
                                        <div>Microsoft Configuration Manager can be used as tool to manage your devices and perform various tasks, which includes the ability to create and
                                            run powershell scripts.</div>
                                        <div>
                                            These scripts may access data iteratively, please ensure sure you recognize any scripts running on your machines.
                                        </div>
                                        <div>
                                            Click <a href={"https://learn.microsoft.com/en-us/mem/configmgr/apps/deploy-use/create-deploy-scripts#script-monitoring"} rel="noreferrer" target="_blank"
                                                     className={"text-blue-600 underline dark:text-blue-500 hover:no-underline"}>
                                            here</a> for more information about the Configuration Manager scripts, or speak to a Cyber Crucible threat hunter for more details as necessary.
                                        </div>
                                    </div>
                                setMoreInfoModalText(textDiv)
                                setMoreInformationModalOpen(true)
                            }}
                        />
                    }
                }
                return(
                    <div className={"flex flex-nowrap items-center gap-x-1"}>
                        {detailsDiv}
                        {params.valueFormatted}
                    </div>
                )
            },
            sortable: true
        },
        { field: "programArgumentsEncoded", headerName: "Program Arguments", initialWidth: 600,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],

                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 2,
            },
            //valueFormatter: base64DecodedValueFormatter,
            valueFormatter:
                function(params){
                    if(params.node.data) {
                        let path = ""
                        let programArgs = ""
                        if(params.node.data.pathEncoded){
                            try{
                                path = atob(params.node.data.pathEncoded)
                            } catch (e) {}
                        }
                        if(params.node.data.programArgumentsEncoded){
                            try{
                                programArgs = atob(params.node.data.programArgumentsEncoded)
                            } catch (e) {}
                        }
                        try{
                            return removePathFromStartOfProgramArgumentsHelper(path, programArgs)
                        }
                        catch(error){
                            return null
                        }
                    }
                    else{
                        return ""
                    }
                },
            sortable: true
        },
        { field: "parentPathEncoded", headerName: "Parent Program Path", initialWidth: 600,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],
                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 2,
            },
            valueFormatter: base64DecodedValueFormatter,
            sortable: true
        },
        { field: "parentProgramArgumentsEncoded", headerName: "Parent Program Arguments", initialWidth: 600,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],
                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 2,
            },
            valueFormatter:
                function(params){
                    if(params.node.data) {
                        let path = ""
                        let programArgs = ""
                        if(params.node.data.parentPathEncoded){
                            try{
                                path = atob(params.node.data.parentPathEncoded)
                            } catch (e) {}
                        }
                        if(params.node.data.parentProgramArgumentsEncoded){
                            try{
                                programArgs = atob(params.node.data.parentProgramArgumentsEncoded)
                            } catch (e) {}
                        }
                        try{
                            return removePathFromStartOfProgramArgumentsHelper(path, programArgs)
                        }
                        catch(error){
                            return null
                        }
                    }
                    else{
                        return ""
                    }
                },
            sortable: true
        },
        { field: "dateCreatedRounded", headerName: "Created", initialWidth: 280,
            filter: 'agDateColumnFilter',
            filterParams:dateFilterParametersInHeaderSuppressSorting(2),
            sortable: true,
            valueFormatter: dateValueFormatter
        },
        { field: "whitelistAppliedId", headerName: "Excluded", initialWidth: 200,
            filter: 'agMultiColumnFilter',
            filterParams: {
                //allow for two filters to show in filter menu, one for excluded, and one for silent
                filters: [
                    {
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            buttons: ["reset", "apply", "cancel"],
                            values: whitelistedFilterValueOptions,
                            suppressSorting: true,
                        },
                    },
                    {
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            buttons: ["reset", "apply", "cancel"],
                            values: ['Silent', 'Not Silent'],
                            suppressSorting: true,
                        },
                    },
                ],
            },
            valueFormatter: function(params){
                if(params.value){
                    return "Excluded"
                }
                else{
                    return ""
                }
            },
            sortable: false
        },
        { field: "deletePath", headerName: "Deleted", initialWidth: 250,
            filter: 'agSetColumnFilter',
            filterParams: {
                buttons: ["reset", "apply", "cancel"],
                values: ["Auto Deleted Exe", "Manually Deleted Exe", "Manual Delete Exe Queued", "None"],
                suppressSorting: true
            },
            valueGetter: (params) => {
                return getIncidentDeletedValueForCell(params)
            },
            valueFormatter: function (params) {
                if (params.value === "None") {
                    return "" //Show blank in cell
                }
                return params.value

            },
            sortable: false
        }
    ])
    const [fullGridInitialColumnDefs, setFullGridInitialColumnDefs] = useState([
        defaultZenGroupColumnInitWithOptionsWithValueGetter(true, true, true),
        {
            field: "incidentDisplayName",
            headerName: `Response Name`,
            sortable: true,
            width: 415,
            editable: true,
            cellEditor: "customNameCellEditor",
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],

                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 2,
            },
            valueFormatter: null,
            cellRenderer: (params) => {
                let deletedValue = getIncidentDeletedValueForCellForFullGrid(params)
                let initializeDeleteModalToPass = null
                if(deletedValue === "None"){
                    initializeDeleteModalToPass = initializeDeleteModalForIconClick
                }
                return incidentNameCellRendererFrameworkForIncidentsGrid(params, initializeWhitelistModalForIconClick, initializeDetailsModalForIconClick,
                    initializeTurnSilentSettingToOnForIconClick, initializeTurnSilentSettingToOffForIconClick, "Response", initializeDeleteModalToPass)
            }
        },
        defaultAgentNameColumnInitWithOptions(true, 5),
        { field: "machineName", headerName: "Machine Name", initialWidth: 225,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],

                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 5,
            },
            cellRenderer:function(params){
                let agentLinkDiv = ""
                if(params.data.agentId){
                    //only using agentId for cross-link filter now so only need to check agentId exists
                    agentLinkDiv =
                        <Link to={{pathname:"/private/agents"}} state={{agentDisplayNameClicked: params.node.data.agentDisplayName, zenGroupIdClicked: params.node.data.zenGroupId,
                            agentIdClicked : params.node.data.agentId, machineNameClicked: params.node.data.machineNameForLocationLink}} className="">
                            <MuiIconButtonWithTooltip
                                icon={
                                    <FontAwesomeIcon
                                        className="object-contain"
                                        icon="fa-duotone fa-user-gear"
                                        size="xs"
                                    />
                                }
                                tooltipTitle={"Click to Manage This Agent"}
                                tooltipPlacement={"bottom-start"}
                            />
                        </Link>
                }
                return(
                    <div className={"flex flex-nowrap items-center gap-x-2"}>
                        {agentLinkDiv}
                        {params.value}
                    </div>
                )
            },
            sortable: true,
        },
        { field: "pathEncoded", headerName: "Program Path", initialWidth: 600,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],

                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 2,
            },
            valueFormatter: base64DecodedValueFormatter,
            cellRenderer:function(params){
                let detailsDiv = ""
                //check for chrome path and args for the more info modal, check edgewebview as well
                if(params.valueFormatted && (params.valueFormatted.toLowerCase() === "C:\\Program Files\\Google\\Chrome\\Application\\chrome.exe".toLowerCase()
                    || params.valueFormatted.toLowerCase() === "C:\\Program Files (x86)\\Google\\Chrome\\Application\\chrome.exe".toLowerCase()
                    || /C:\\Program Files.*\\Microsoft\\EdgeWebView\\Application\\.+\\msedgewebview2\.exe/i.test(params.valueFormatted)
                )){
                    let validArgs = false
                    try{
                        let args = atob(params.data.programArgumentsEncoded).toLowerCase()
                        validArgs = checkChromeProgramArgumentsForTuningModal(args)
                    }
                    catch(error){}
                    if(validArgs){
                        detailsDiv = <MuiIconButtonWithTooltip
                            icon={
                                <FontAwesomeIcon className={`object-contain`} icon={"fa-duotone fa-music-note"} size="xs" color={`black`}/>
                            }
                            tooltipTitle={"Tuning Available"} tooltipPlacement={"bottom-start"}
                            onClick={() => {
                                if(params.node.data.zenGroupId){
                                    setZenGroupForTuningModal(params.node.data.zenGroupId)
                                }
                                else{
                                    setZenGroupForTuningModal(null)
                                }
                                setTuningModalIsOpen(true)
                            }}
                        />
                    }
                }
                else if(params.valueFormatted && params.valueFormatted.toLowerCase().trim() === "C:\\Windows\\System32\\WindowsPowerShell\\v1.0\\powershell.exe".toLowerCase()){ //check for powershell path and windows ccm program args
                    let validArgs = false
                    try{
                        let args = atob(params.data.programArgumentsEncoded).toLowerCase()
                        if(args.includes("-ExecutionPolicy Bypass \"& 'C:\\WINDOWS\\CCM\\SystemTemp\\".toLowerCase())){
                            validArgs = true
                        }
                    }
                    catch(error){}

                    let validParentPath = false
                    try{
                        let parentPath = atob(params.data.parentPathEncoded).toLowerCase()
                        if(parentPath && parentPath.trim() === "C:\\Windows\\System32\\wbem\\WmiPrvSE.exe".toLowerCase()){
                            validParentPath = true
                        }
                    } catch (e) {}
                    if(validArgs && validParentPath){
                        detailsDiv = <MuiIconButtonWithTooltip
                            icon={<PrivacyTipIcon color={"action"} className={"cursor-pointer"} />}
                            tooltipTitle={"More Info"}
                            tooltipPlacement={"top"}
                            onClick={() => {
                                let textDiv =
                                    <div className={"flex flex-col gap-y-3"}>
                                        <div>Microsoft Configuration Manager can be used as tool to manage your devices and perform various tasks, which includes the ability to create and
                                            run powershell scripts.</div>
                                        <div>
                                            These scripts may access data iteratively, please ensure sure you recognize any scripts running on your machines.
                                        </div>
                                        <div>
                                            Click <a href={"https://learn.microsoft.com/en-us/mem/configmgr/apps/deploy-use/create-deploy-scripts#script-monitoring"} rel="noreferrer" target="_blank"
                                                     className={"text-blue-600 underline dark:text-blue-500 hover:no-underline"}>
                                            here</a> for more information about the Configuration Manager scripts, or speak to a Cyber Crucible threat hunter for more details as necessary.
                                        </div>
                                    </div>
                                setMoreInfoModalText(textDiv)
                                setMoreInformationModalOpen(true)
                            }}
                        />
                    }
                }
                return(
                    <div className={"flex flex-nowrap items-center gap-x-1"}>
                        {detailsDiv}
                        {params.valueFormatted}
                    </div>
                )
            },
            sortable: true
        },
        { field: "programArgumentsEncoded", headerName: "Program Arguments", initialWidth: 600,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],

                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 2,
            },
            //valueFormatter: base64DecodedValueFormatter,
            valueFormatter:
                function(params){
                    if(params.node.data) {
                        let path = ""
                        let programArgs = ""
                        if(params.node.data.pathEncoded){
                            try{
                                path = atob(params.node.data.pathEncoded)
                            } catch (e) {}
                        }
                        if(params.node.data.programArgumentsEncoded){
                            try{
                                programArgs = atob(params.node.data.programArgumentsEncoded)
                            } catch (e) {}
                        }
                        try{
                            return removePathFromStartOfProgramArgumentsHelper(path, programArgs)
                        }
                        catch(error){
                            return null
                        }
                    }
                    else{
                        return ""
                    }
                },
            sortable: true
        },
        { field: "parentPathEncoded", headerName: "Parent Program Path", initialWidth: 600,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],
                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 2,
            },
            valueFormatter: base64DecodedValueFormatter,
            sortable: true
        },
        { field: "parentProgramArgumentsEncoded", headerName: "Parent Program Arguments", initialWidth: 600,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],
                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 2,
            },
            valueFormatter:
                function(params){
                    if(params.node.data) {
                        let path = ""
                        let programArgs = ""
                        if(params.node.data.parentPathEncoded){
                            try{
                                path = atob(params.node.data.parentPathEncoded)
                            } catch (e) {}
                        }
                        if(params.node.data.parentProgramArgumentsEncoded){
                            try{
                                programArgs = atob(params.node.data.parentProgramArgumentsEncoded)
                            } catch (e) {}
                        }
                        try{
                            return removePathFromStartOfProgramArgumentsHelper(path, programArgs)
                        }
                        catch(error){
                            return null
                        }
                    }
                    else{
                        return ""
                    }
                },
            sortable: true
        },
        { field: "dateCreatedRounded", headerName: "Created", initialWidth: 280,
            hide: true, suppressColumnsToolPanel: true, lockVisible: true,
            filter: 'agDateColumnFilter',
            filterParams:dateFilterParametersInHeaderSuppressSorting(2),
            sortable: true,
            valueFormatter: dateValueFormatter
        },
        { field: "created", headerName: "Created", width: 280,
            filter: 'agDateColumnFilter',
            filterParams:dateFilterParametersInHeaderSuppressSorting(2),
            sortable: true,
            valueFormatter: dateValueFormatter
        },
        { field: "collected", headerName: "Collected", width: 280,
            filter: 'agDateColumnFilter',
            filterParams:dateFilterParametersInHeaderSuppressSorting(2),
            sortable: true,
            valueFormatter: dateValueFormatter
        },
        { field: "whitelistAppliedId", headerName: "Excluded", initialWidth: 200,
            filter: 'agMultiColumnFilter',
            filterParams: {
                //allow for two filters to show in filter menu, one for excluded, and one for silent
                filters: [
                    {
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            buttons: ["reset", "apply", "cancel"],
                            values: whitelistedFilterValueOptions,
                            suppressSorting: true,
                        },
                    },
                    {
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            buttons: ["reset", "apply", "cancel"],
                            values: ['Silent', 'Not Silent'],
                            suppressSorting: true,
                        },
                    },
                ],
            },
            valueFormatter: function(params){
                if(params.value){
                    return "Excluded"
                }
                else{
                    return ""
                }
            },
            sortable: false
        },
        { field: "zenGroupId", hide: true, suppressColumnsToolPanel: true, lockVisible: true},
        {
            field: "rootCauseAnalysis", headerName: "Root Cause Analysis", width: 300,
            sortable: false,
            valueFormatter: function (params) {
                if (params.node.data.rootCauseAnalysis) {
                    return params.node.data.rootCauseAnalysis
                }
                let path = null
                try{
                    path = atob(params.node.data.pathEncoded)
                } catch (e) {}
                if (path && params.node.data.incidentId && params.node.data.zenGroupId && params.node.data.uniqueProcessIdentifier !== null && params.node.data.uniqueProcessIdentifier !== undefined) {
                    checkIncidentHasRelatedProcessInjectionsAndCreationsReactive(params.node.data.incidentId, params.node.data.zenGroupId, params.node.data.uniqueProcessIdentifier, path).then(response => {
                        params.node.data.relatedProcessCreationExists = response.relatedProcessCreationExists
                        params.node.data.relatedProcessInjectionExists = response.relatedProcessInjectionExists
                        params.node.data.memoryFileExists = response.memoryFileExists
                        params.node.data.relatedUntrustedDLLExists = params.node.data.untrustedModuleWasLoaded //make new variable so it won't appear in cell until query is finished
                        //Show the Related Processes Found text over Memory Download Available if either fields are true
                        if (response.relatedProcessCreationExists || response.relatedProcessInjectionExists) {
                            params.node.setDataValue("rootCauseAnalysis", "Related Processes Found")
                        } else {
                            //If we have memoryFileExists true then we can show some text, else show nothing
                            if(response.memoryFileExists){
                                params.node.setDataValue("rootCauseAnalysis", "Memory Diff Download Available")
                            }
                            else if(params.node.data.relatedUntrustedDLLExists){
                                params.node.setDataValue("rootCauseAnalysis", "Untrusted Modules Found")
                            }
                            else{
                                params.node.setDataValue("rootCauseAnalysis", " ") //lets cell know not to call checkIncidentHasRelatedProcessInjectionsAndCreationsReactive again
                            }
                        }
                    }).catch(function (error) {
                        params.node.setDataValue("rootCauseAnalysis", " ") //lets cell know not to call checkIncidentHasRelatedProcessInjectionsAndCreationsReactive again
                    })
                    params.node.data.rootCauseAnalysis = params.node.data.zenGroupId
                    return params.node.data.zenGroupId
                }
            },
            cellRenderer: function (params) {
                let spinnerDiv = ""
                let memoryFileDownloadIcon = ""
                let processCreationsLinkDiv = ""
                let processInjectionsLinkDiv = ""
                let dllsDiv = ""
                let path = null
                try{
                    path = atob(params.node.data.pathEncoded)
                } catch (e) {}
                if (path && params.node.data.zenGroupId && params.node.data.uniqueProcessIdentifier !== null && params.node.data.uniqueProcessIdentifier !== undefined) {
                    if (params.node.data.rootCauseAnalysis === params.node.data.zenGroupId) {
                        spinnerDiv = <FontAwesomeIcon
                            className="contain fa-pulse mr-1"
                            icon="fa-light fa-spinner"
                            size="lg"
                            name="relatedProcessesLoading"
                        />
                    } else {
                        spinnerDiv = ""
                    }
                    //Check if we should show Memory file download icon
                    if (params.node.data.memoryFileExists === true) {
                        memoryFileDownloadIcon =
                            <div className={"mb-1"}>
                                <MuiIconButtonWithTooltip
                                    icon={ <FontAwesomeIcon
                                        className="object-contain"
                                        icon="fa-duotone fa-download"
                                        size="xs"
                                    />}
                                    tooltipTitle={"Click to download the Memory Diff File for this Extortion Response. Please contact support for more information about this file."}
                                    tooltipPlacement={"bottom-start"}
                                    onClick={() => {
                                        if(params.node.data.incidentId){
                                            getCCDiffFileReactive(params.node.data.incidentId).then(response => {
                                                try{
                                                    let incidentName = params.node.data.incidentDisplayName
                                                    let bytes = base64ToArrayBuffer(response.data); // pass your byte response to this constructor
                                                    let blob = new Blob([bytes], {type: "application/octet-stream"});// change resultByte to bytes
                                                    //Add in local datetime string to filename down to the minutes, and this is in 24-hour time format
                                                    let today = new Date();
                                                    let date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
                                                    let time = today.getHours() + "-" + today.getMinutes();
                                                    let dateTime = date+'T'+time;
                                                    let link=document.createElement('a');
                                                    link.href=window.URL.createObjectURL(blob);
                                                    let agentNameOfMaster = params.node.data.agentDisplayName
                                                    if(agentNameOfMaster === null || agentNameOfMaster === undefined || agentNameOfMaster.trim().length < 1){
                                                        agentNameOfMaster = params.node.data.agentId
                                                    }

                                                    link.download=`${agentNameOfMaster}-${incidentName}-${dateTime}.ccdiff`;
                                                    link.click();
                                                }
                                                catch(error){
                                                    NotificationManager.error("Unexpected error making this request");
                                                }
                                            }).catch(function (error) {
                                                if(error.message){
                                                    NotificationManager.error(error.message);
                                                }
                                                else{
                                                    NotificationManager.error("Unexpected error making this request");
                                                }
                                            })
                                        }
                                        else{
                                            NotificationManager.error("Unexpected error making this request");
                                        }
                                    }}
                                />
                            </div>
                    }

                    //Links
                    if (params.node.data.relatedProcessCreationExists === true) {
                        processCreationsLinkDiv =
                            <Link to={{
                                pathname: "/private/processCreations"
                            }} state={{
                                uniqueProcessIdentifier: params.node.data.uniqueProcessIdentifier,
                                zenGroupIdClicked: params.node.data.zenGroupId,
                                childPath: path,
                                agentIdClicked: params.node.data.agentId
                            }} className="">
                                <div className={"mb-1"}>
                                    <MuiIconButtonWithTooltip
                                        icon={
                                            <FontAwesomeIcon
                                                className="object-contain"
                                                icon="fa-duotone fa-magnifying-glass-arrow-right"
                                                size="xs"
                                            />
                                        }
                                        tooltipTitle={"Click to view related process creations"}
                                        tooltipPlacement={"bottom-start"}
                                    />
                                </div>
                            </Link>
                    }
                    if (params.node.data.relatedProcessInjectionExists === true) {
                        processInjectionsLinkDiv =
                            <Link to={{
                                pathname: "/private/processInjections"
                            }} state={{
                                uniqueProcessIdentifier: params.node.data.uniqueProcessIdentifier,
                                zenGroupIdClicked: params.node.data.zenGroupId,
                                agentIdClicked: params.node.data.agentId
                            }} className="">
                                <div className={"mb-1"}>
                                    <MuiIconButtonWithTooltip
                                        icon={
                                            <FontAwesomeIcon
                                                className="object-contain"
                                                icon="fa-duotone fa-syringe"
                                                size="xs"
                                            />
                                        }
                                        tooltipTitle={"Click to view related process injections"}
                                        tooltipPlacement={"bottom-start"}
                                    />
                                </div>
                            </Link>
                    }
                    if (params.node.data.relatedUntrustedDLLExists === true) {
                        dllsDiv =
                            <div className={"mb-1"}>
                                <MuiIconButtonWithTooltip
                                    icon={
                                        <FontAwesomeIcon
                                            className="object-contain"
                                            icon="fa-duotone fa-shield-xmark"
                                            size="xs"
                                        />
                                    }
                                    tooltipTitle={"Click to view the untrusted Modules for this response"}
                                    tooltipPlacement={"bottom-start"}
                                    onClick={() => {
                                        let baseUrl = "/private/relatedDLLs";
                                        let urlSearchParams = new URLSearchParams();
                                        urlSearchParams.append("uniqueProcessIdentifier", JSON.stringify(params.node.data.uniqueProcessIdentifier));
                                        urlSearchParams.append("agentId", JSON.stringify(params.node.data.agentId));
                                        urlSearchParams.append("zenGroupId", JSON.stringify(params.node.data.zenGroupId));

                                        /*
                                            Note that our service might not have populated ops database collection with the related dll, so check incident date collected time.
                                            The service runs every hour, but check if incident date is within the past 5 hours then set showAllTelemetry to true to give service
                                            time to populate ops db
                                         */
                                        let showAllTelemetry = false //Default to false so dlls page knows to send false for showAllTelemetry in req for query since dlls in ops db will not expire
                                        if(params.node.data.collected){
                                            try{
                                                let dateCollected = new Date(params.node.data.collected)
                                                let currentDate = new Date()
                                                currentDate.setHours(currentDate.getHours() - 5)
                                                if(dateCollected.getTime() >= currentDate.getTime()){
                                                    showAllTelemetry = true
                                                }
                                            } catch (e) {}
                                        }

                                        urlSearchParams.append("showAllTelemetry", JSON.stringify(showAllTelemetry));


                                        let urlWithParams = `${baseUrl}?${urlSearchParams.toString()}`;
                                        let rememberMeEnabled = checkIsUsingRememberMe()
                                        if(rememberMeEnabled){
                                            //for now, if using rem me then open in new tab
                                            window.open(urlWithParams, "_blank", "noreferrer");
                                        }
                                        else{
                                            //for now, if not using rem me then we have to open in same tab
                                            window.open(urlWithParams, "_self", "noreferrer");
                                        }
                                    }}
                                />
                            </div>
                    }
                }

                return (
                    <div className={"flex flex-nowrap items-center justify-start gap-x-0"}>
                        {spinnerDiv}
                        {memoryFileDownloadIcon}
                        {processCreationsLinkDiv}
                        {processInjectionsLinkDiv}
                        {dllsDiv}
                        {params.node.data.rootCauseAnalysis}
                    </div>
                )
            }
        },
        { field: "status", headerName: "Status", width: 275,
            //Only status values are auto suspended so don't even let this be filterable
            /*filter: 'agSetColumnFilter',
            filterParams: {
                buttons: ["reset", "apply", "cancel"],
                //values: ["AUTOMATICALLY_BLOCKED", "AUTOMATICALLY_HIDDEN", "AUTOMATICALLY_SUSPENDED"], //WHITELISTED has its own col so don't include here
                valueFormatter: function(params){
                    if(params.value === "WHITELISTED"){
                        return "Excluded"
                    }
                    else{
                        if(params.value === "AUTOMATICALLY_SUSPENDED"){
                            return "Automatically Suspended"
                        }
                        else if(params.value === "AUTOMATICALLY_HIDDEN"){
                            return "Automatically Hidden"
                        }
                        else if(params.value === "AUTOMATICALLY_BLOCKED"){
                            return "Automatically Blocked"
                        }
                        else{
                            return params.value
                        }
                    }
                },
                showTooltips: true
            },*/
            valueFormatter: function(params){
                if(params.value === "WHITELISTED"){
                    return "Excluded"
                }
                else{
                    if(params.value === "AUTOMATICALLY_SUSPENDED"){
                        return "Automatically Suspended"
                    }
                    else if(params.value === "AUTOMATICALLY_HIDDEN"){
                        return "Automatically Hidden"
                    }
                    else if(params.value === "AUTOMATICALLY_BLOCKED"){
                        return "Automatically Blocked"
                    }
                    else{
                        return params.value
                    }
                }
            },
            sortable: true
        },
        { field: "accessedFilePath", headerName: "Data Access Attempted", initialWidth: 450,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],
                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 2,
            },
            sortable: true,
            valueGetter: function (params) {
                return handleCanaryPath(params.node.data.accessedFilePath)
            }
        },
        {
            //field that is set by us for getting either whitelist name or silent incident/response name(s)
            field: "hidingRule", headerName: "Hiding Rule", width : 430, sortable: false,
            valueFormatter: function(params){
                if(params.node.data.hidingRule){
                    return params.node.data.hidingRule
                }
                if(params.node.data.whitelistAppliedId){
                    //call for whitelist name that is associated with whitelistAppliedId
                    let whitelistId = params.node.data.whitelistAppliedId
                    findBySingleWhitelistAppliedIdReactive(whitelistId).then(function(response){
                        if(response.whitelistName !== null){
                            params.node.setDataValue("hidingRule", response.whitelistName)
                        }
                        else{
                            params.node.setDataValue("hidingRule", "(The tailored behavior applied at the time of response was deleted)")
                        }
                        /*if(response.whitelist !== null){
                            params.node.data.tooltipData = response.whitelist
                        }*/
                    }).catch(function (error) {
                        params.node.setDataValue("hidingRule", " ")
                    })
                    params.node.data.hidingRule = whitelistId
                }
                else{
                    //else if incident was not whitelisted then check the silent field
                    if(params.node.data.silent){
                        let incidentId = params.node.data.incidentId
                        findSilentIncidentNamesForSingleIncidentIdReactive(incidentId).then(function(silentIncidentsList){
                            let listString = " "
                            let namesSet = new Set();
                            if(silentIncidentsList && silentIncidentsList.length > 0){
                                silentIncidentsList.forEach(silentIncident => {
                                    if(silentIncident.silentIncidentDisplayName){
                                        namesSet.add(silentIncident.silentIncidentDisplayName)
                                    }
                                })
                                //convert set to array and join values together into one string to show in cell
                                listString = Array.from(namesSet).join(' | ')
                                //listString = Array.from(namesSet).join(', ')
                            }
                            params.node.setDataValue("hidingRule", listString)
                        }).catch(function (error) {
                            params.node.setDataValue("hidingRule", " ")
                        })
                        params.node.data.hidingRule = incidentId
                    }
                    else{
                        //don't show anything for incidents that aren't silent, but need to set dataValue so the spinner will stop in the cell renderer
                        params.node.setDataValue("hidingRule", " ")
                    }
                }
                return null
            },
            cellRenderer: function(params){
                let spinnerDiv = ""
                if(params.node.data.hidingRule === null || params.node.data.hidingRule === undefined || params.node.data.hidingRule === params.node.data.whitelistAppliedId ||
                    params.node.data.hidingRule === params.node.data.incidentId){
                    spinnerDiv =
                        <div>
                            <FontAwesomeIcon
                                className="contain fa-pulse mr-1"
                                icon="fa-light fa-spinner"
                                size="lg"
                                name="hidingRuleSpinner"
                            />
                        </div>
                }
                return(
                    <div className={"flex flex-nowrap items-center gap-x-2"}>
                        {spinnerDiv}
                        {params.node.data.hidingRule}
                    </div>
                )
            },
        },
        { field: "incidentType", headerName: "File Access Trigger", width: 250,
            filter: 'agSetColumnFilter',
            filterParams: {
                buttons: ["reset", "apply", "cancel"],
                valueFormatter: (params) => {
                    if(params.value!=="(Select All)"){
                        return params.value.charAt(0).toUpperCase() + params.value.slice(1).toLowerCase();
                    }
                    else{
                        return params.value;
                    }
                },
                //File Attributes is for both SET_INFO and TIMESTAMP_OR_LEGAL_ATTRS, backend accounts for this in filter for this incidentType field
                values: ["DELETE", "READ", "RENAME", fileAttributesString, "WRITE"],
            },
            sortable: true,
            valueFormatter:
                function(params){
                    if(params.value) {
                        //if the incidentType is TIMESTAMP_OR_LEGAL_ATTRS or SET_INFO, return "File Attributes" for a better customer facing value, else return the value with first letter capitalized
                        switch(params.value) {
                            case "TIMESTAMP_OR_LEGAL_ATTRS":
                                return fileAttributesString
                            case "SET_INFO":
                                return fileAttributesString
                            default:
                                //return first letter capitalized
                                return params.value.charAt(0).toUpperCase() + params.value.slice(1).toLowerCase();
                        }
                    }
                },
        },
        { field: "hasUntrustedRemoteThreads", headerName: "Untrusted Remote Threads", width: 325,
            filter: 'agSetColumnFilter',
            filterParams: {
                buttons: ["reset", "apply", "cancel"],
                valueFormatter: (params) => {
                    if(params.value!=="(Select All)"){
                        switch(params.value) {
                            case "UNKNOWN":
                                return "Unknown"
                            case "TRUE":
                                return "True"
                            case "FALSE":
                                return "False"
                            default:
                                return "";
                        }
                    }
                    else{
                        return params.value;
                    }
                },
                values: ['FALSE', 'TRUE', 'UNKNOWN'],
                suppressSorting: true,
            },
            valueFormatter:
                function (params) {
                    if(params.node.data.hasUntrustedRemoteThreads){
                        switch(params.node.data.hasUntrustedRemoteThreads) {
                            case "UNKNOWN":
                                return "Unknown"
                            case "TRUE":
                                return "True"
                            case "FALSE":
                                return "False"
                            default:
                                return "";
                        }
                    }else{
                        return ""
                    }
                },
            sortable: true
        },
        { field: "hasModifiedMem", headerName: "Modified Memory", width: 230,
            filter: 'agSetColumnFilter',
            filterParams: {
                buttons: ["reset", "apply", "cancel"],
                valueFormatter: (params) => {
                    if(params.value!=="(Select All)"){
                        switch(params.value) {
                            case "UNKNOWN":
                                return "Unknown"
                            case "TRUE":
                                return "True"
                            case "FALSE":
                                return "False"
                            default:
                                return "";
                        }
                    }
                    else{
                        return params.value;
                    }
                },
                values: ['FALSE', 'TRUE', 'UNKNOWN'],
                suppressSorting: true,
            },
            valueFormatter:
                function (params) {
                    if(params.node.data.hasModifiedMem){
                        switch(params.node.data.hasModifiedMem) {
                            case "UNKNOWN":
                                return "Unknown"
                            case "TRUE":
                                return "True"
                            case "FALSE":
                                return "False"
                            default:
                                return "";
                        }
                    }else{
                        return ""
                    }
                },
            sortable: true
        },
        { field: "hasNoTrustedCert", headerName: "No Trusted Cert", width: 230,
            filter: 'agSetColumnFilter',
            filterParams: {
                buttons: ["reset", "apply", "cancel"],
                valueFormatter: (params) => {
                    if(params.value!=="(Select All)"){
                        switch(params.value) {
                            case "UNKNOWN":
                                return "Unknown"
                            case "TRUE":
                                return "True"
                            case "FALSE":
                                return "False"
                            default:
                                return "";
                        }
                    }
                    else{
                        return params.value;
                    }
                },
                values: ['FALSE', 'TRUE', 'UNKNOWN'],
                suppressSorting: true,
            },
            valueFormatter:
                function (params) {
                    if(params.node.data.hasNoTrustedCert){
                        switch(params.node.data.hasNoTrustedCert) {
                            case "UNKNOWN":
                                return "Unknown"
                            case "TRUE":
                                return "True"
                            case "FALSE":
                                return "False"
                            default:
                                return "";
                        }
                    }else{
                        return ""
                    }
                },
            cellRenderer: function(params){
                let iconDiv = ""
                if(params.node.data.windowsCode === 258){ //Timeout
                    iconDiv = <MuiIconButtonWithTooltip
                        icon={<TimerOffOutlinedIcon className={"cursor-pointer"}/>}
                        tooltipTitle={`Timeout occurred retrieving cert information from Windows`}
                        tooltipPlacement={"bottom-start"}
                    />
                }
                else if(params.node.data.windowsCode === 3221225527){ //Disconnect
                    iconDiv = <MuiIconButtonWithTooltip
                        icon={<VpnKeyOffOutlinedIcon className={"cursor-pointer"}/>}
                        tooltipTitle={`Disconnect occurred retrieving cert information from Windows. Reconnection was automatically restarted`}
                        tooltipPlacement={"bottom-start"}
                    />
                }
                return(
                    <div className={"flex flex-nowrap items-center gap-x-2"}>
                        {iconDiv}
                        {params.valueFormatted}
                    </div>
                )
            },
            sortable: true
        },
        { field: "hasModifiedDllMem", headerName: "Modified Module Memory", width: 260,
            filter: 'agSetColumnFilter',
            filterParams: {
                buttons: ["reset", "apply", "cancel"],
                valueFormatter: (params) => {
                    if(params.value!=="(Select All)"){
                        switch(params.value) {
                            case "UNKNOWN":
                                return "Unknown"
                            case "TRUE":
                                return "True"
                            case "FALSE":
                                return "False"
                            default:
                                return "";
                        }
                    }
                    else{
                        return params.value;
                    }
                },
                values: ['FALSE', 'TRUE', 'UNKNOWN'],
                suppressSorting: true,
            },
            valueFormatter:
                function (params) {
                    if(params.node.data.hasModifiedDllMem){
                        switch(params.node.data.hasModifiedDllMem) {
                            case "UNKNOWN":
                                return "Unknown"
                            case "TRUE":
                                return "True"
                            case "FALSE":
                                return "False"
                            default:
                                return "";
                        }
                    }else{
                        return ""
                    }
                },
            sortable: true
        },
        { field: "modifiedModuleIdentifier", headerName: "Modified Module Identifier", initialWidth: 600,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],
                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 2,
            },
            sortable: true
        },
        { field: "modifiedModulePath", headerName: "Modified Module Path", initialWidth: 600,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],
                filterOptions: ['equals'], //can only do equals for this because we mongo can return a BSON size limit error if we do a contains .dll for example, since that will be the entire collection
                maxNumConditions: 5,
            },
            sortable: true,
            valueFormatter: function (params) {
                if(params.node.data.modifiedModuleIdentifier === null || params.node.data.modifiedModuleIdentifier === undefined){
                    return " "
                }
                if (params.node.data.modifiedModulePath) {
                    return params.node.data.modifiedModulePath
                }
                if (params.node.data.incidentId) {
                    getDLLPathForDataIncidentReactive(params.node.data.incidentId).then(response => {
                        if (response.path !== null && response.path !== undefined) {
                            params.node.setDataValue("modifiedModulePath", response.path)
                        } else {
                            params.node.setDataValue("modifiedModulePath", " ")
                        }
                    }).catch(function (error) {
                        params.node.setDataValue("modifiedModulePath", " ") //lets cell know not to call getDLLPathForDataIncidentReactive again
                    })
                    params.node.data.modifiedModulePath = params.node.data.zenGroupId
                    return params.node.data.zenGroupId
                }
            },
            cellRenderer: function (params) {
                let spinnerDiv = ""
                if (params.node.data.modifiedModuleIdentifier !== null && params.node.data.modifiedModuleIdentifier !== undefined) {
                    if (params.node.data.modifiedModulePath === params.node.data.zenGroupId) {
                        spinnerDiv = <FontAwesomeIcon
                            className="contain fa-pulse mr-1"
                            icon="fa-light fa-spinner"
                            size="lg"
                            name="dllPathLoading"
                        />
                    } else {
                        spinnerDiv = ""
                    }
                }

                return (
                    <div className={"flex flex-nowrap items-center justify-start gap-x-0"}>
                        {spinnerDiv}
                        {params.node.data.modifiedModulePath}
                    </div>
                )
            }
        },
        { field: "modifiedModuleOriginalMemoryHash", headerName: "Modified Module Original Memory Hash", initialWidth: 400,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],
                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 2,
            },
            sortable: true
        },
        { field: "modifiedModuleCurrentMemoryHash", headerName: "Modified Module Current Memory Hash", initialWidth: 400,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],
                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 2,
            },
            sortable: true
        },
        { field: "certPublisherNames", headerName: "Cert Publisher Names List", hide: true, sortable: true, width: 500, suppressColumnsToolPanel: true,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],

                filterOptions: ['contains'],
                maxNumConditions: 1,
            }
        },
        { field: "username", headerName: "Username", initialWidth: 320,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],

                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 2,
            },
            sortable: true
        },
        { field: "uniqueProcessIdentifier.bootGuid", headerName: "Process Execution GUID", initialWidth: 375,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],

                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 2,
            },
            sortable: true,
            cellRenderer: function (params) {
                return (
                    <div className={`flex flex-row items-center gap-x-1`}>
                        <div className={""}>
                            <MuiIconButtonWithTooltip
                                icon={
                                    <FontAwesomeIcon
                                        className="object-contain"
                                        icon="fa-light fa-circle-info"
                                        size="xs"
                                    />
                                }
                                tooltipTitle={"The process execution guid is a unique identifier for the time period between boot and shutdown/restart. Pid reuse numbers are unique per boot guid."}
                                tooltipPlacement={"bottom-start"}
                            />
                        </div>
                        {params.value}
                    </div>
                )
            }
        },
        { field: "pid", headerName: "Pid", initialWidth: 150,
            filter: 'agNumberColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],

                filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual'],
                maxNumConditions: 2,
            },
            sortable: true
        },
        { field: "uniqueProcessIdentifier.reuseCount", headerName: "Pid Reuse Number", initialWidth: 250,
            filter: 'agNumberColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],

                filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual'],
                maxNumConditions: 2,
            },
            sortable: true
        },
        { field: "userSid", headerName: "User Sid", hide: true, sortable: true, initialWidth: 500, suppressColumnsToolPanel: true, lockVisible: true,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],

                filterOptions: ['contains'],
                maxNumConditions: 2,
            }
        },
        { field: "agentVersionFormatted", headerName: "Agent Version", width: 225,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],

                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 2,
            },
            sortable: true,
            valueFormatter: agentVersionFormatter,
            cellRenderer: function(params){
                let spinnerDiv = ""
                if(params.node.data.agentId === params.valueFormatted ){
                    spinnerDiv = <FontAwesomeIcon
                        className="contain fa-pulse"
                        icon="fa-light fa-spinner"
                        size="lg"
                        name="agentVersionLoading"
                    />
                }else{
                    spinnerDiv = ""
                }
                return(
                    <div id ="fortooltip" className={"flex flex-nowrap items-center gap-x-2"}>
                        {spinnerDiv}
                        {params.valueFormatted}
                    </div>
                )
            },
        },
        { field: "currentLatestAgentVersion", headerName: "Latest Agent Version", width: 275,
            filter: 'agTextColumnFilter',
            filterParams: {
                suppressSorting: true,
                buttons: ["reset", "apply"],

                filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                maxNumConditions: 2,
            },
            sortable: true,
        },
        { field: "deletePath", headerName: "Deleted", initialWidth: 250,
            filter: 'agSetColumnFilter',
            filterParams: {
                buttons: ["reset", "apply", "cancel"],
                values: ["Auto Deleted Exe", "Manually Deleted Exe", "Manual Delete Exe Queued", "None"],
                suppressSorting: true
            },
            valueGetter: (params) => {
                return getIncidentDeletedValueForCellForFullGrid(params)
            },
            valueFormatter: function (params) {
                if (params.value === "None") {
                    return "" //Show blank in cell
                }
                return params.value

            },
            sortable: false
        }

    ])

    const [defaultColDef, setDefaultColDef] = useState(
        {
            resizable: true,
            filterParams: null,
            floatingFilter: true,
            headerClass: "border-0 border-b-0",
            cellClass: "outline:none",
            enableCellChangeFlash: true,
            autoHeight: false,
            cellDataType: false //disable inferring cell data type automatically, can be overridden in individual colDef
        }
    )
    const sideBar = useMemo(() => {
        //Inside useMemo to help prevent the sidebar from re-rendering
        return getDefaultAgGridSidebarProps(300)
    }, []);
    const rowSelection = useMemo(() => {
        return {
            mode: 'singleRow',
            enableClickSelection: true,
            checkboxes: false,
            headerCheckbox: false
        };
    }, []);
    //chart options for included and not including whitelisted incidents
    let chartWithoutWhitelistedCountOptions={
        autoSize: true,
        data: chartDataWithoutWhitelistedCount,
        title: {
            text: 'Responses Per Group',
            fontSize: 18,
        },
        subtitle: {
            text: 'Over the last 30 days',
            fontSize: 15,
            spacing: 15
        },
        series: [
            {
                type: 'bar',
                xKey: 'zenGroupId',
                yKey: 'countWithoutWhitelisted',
                yName:  'Number of Responses',
                fill: '#e76a24',
                stroke: '#c2c2c2',
                highlightStyle: {
                    item: {
                        fill: "#E8E8E8",
                        stroke: "#181818",
                        strokeWidth: 1
                    },
                },
                tooltip: { //for hovering over a column
                    renderer: function (params) {
                        let content = params.datum.zenGroupName + ": " + params.datum[params.yKey]
                        return {
                            title: params.yName,
                            content: content
                        };
                    },
                },
            },
        ],
        axes: [
            {
                type: 'category',
                position: 'bottom',
                keys: ["zenGroupId"],
                label: {
                    rotation: 50,
                    formatter: function(params){
                        //The params include the zenGroupId (params.value) and the index of the label in the chart data array, so we can access the object and format return value
                        let index = params.index //index of the chart data array
                        if(chartDataWithoutWhitelistedCount && index !== undefined && index !== null){
                            try{
                                let object = chartDataWithoutWhitelistedCount[index]
                                if(object){
                                    let name = params.value //initialize to zenGroupId (params.value) in case no zenGroupName found
                                    if(object.zenGroupName){
                                        name = object.zenGroupName
                                    }
                                    if(object.countWithoutWhitelisted !== null && object.countWithoutWhitelisted !== undefined){
                                        return `${name} (${object.countWithoutWhitelisted})`
                                    }
                                    else{
                                        //should not get to here but default to return name
                                        return name
                                    }
                                }
                            } catch (e) {}
                        }
                        return params.value //if we get to here then something went wrong, return zenGroupId (params.value)
                    },
                    fontSize: 11
                },
            },
            {
                type: 'number',
                position: 'left',
            },
        ],
        legend: {
            spacing: 40,
            position: 'top',
            enabled: true
        },
    }
    let chartWithWhitelistedCountOptions={
        autoSize: true,
        data: chartDataWithWhitelistedCount,
        title: {
            text: 'Responses Per Group',
            fontSize: 18,
        },
        subtitle: {
            text: 'Over the last 30 days',
            fontSize: 15,
            spacing: 15
        },
        series: [
            {
                type: 'bar',
                stacked: true,
                xKey: 'zenGroupId',
                yKey: 'countWithoutWhitelisted',
                yName: 'Number of Responses',
                fill: '#e76a24',
                stroke: '#c2c2c2',
                strokeWidth: 1,
                highlightStyle: {
                    item: {
                        fill: "#E8E8E8",
                        stroke: "#181818",
                        strokeWidth: 1
                    },
                },
                tooltip: { //for hovering over a column
                    renderer: function (params) {
                        let content = params.datum.zenGroupName + ": " + params.datum[params.yKey]
                        return {
                            title: params.yName,
                            content: content
                        };
                    },
                },
            },
            {
                type: 'bar',
                stacked: true,
                xKey: 'zenGroupId',
                yKey: 'whitelistedIncidentsCount',
                yName: 'Number of Excluded Responses',
                fill: '#4194a5',
                stroke: '#c2c2c2',
                strokeWidth: 1,
                highlightStyle: {
                    item: {
                        fill: "#E8E8E8",
                        stroke: "#181818",
                        strokeWidth: 1
                    },
                },
                tooltip: { //for hovering over a column
                    renderer: function (params) {
                        let content = params.datum.zenGroupName + ": " + params.datum[params.yKey]
                        return {
                            title: params.yName,
                            content: content
                        };
                    },
                },
            },
        ],
        axes: [
            {
                type: 'category',
                position: 'bottom',
                keys: ["zenGroupId"],
                label: {
                    rotation: 50,
                    formatter: function(params){
                        //The params include the zenGroupId (params.value) and the index of the label in the chart data array, so we can access the object and format return value
                        let index = params.index //index of the chart data array
                        if(chartDataWithWhitelistedCount && index !== undefined && index !== null){
                            try{
                                let object = chartDataWithWhitelistedCount[index]
                                if(object){
                                    let name = params.value //initialize to zenGroupId (params.value) in case no zenGroupName found
                                    if(object.zenGroupName){
                                        name = object.zenGroupName
                                    }
                                    if(object.countWithoutWhitelisted !== null && object.countWithoutWhitelisted !== undefined && object.whitelistedIncidentsCount !== null && object.whitelistedIncidentsCount !== undefined){
                                        return `${name} (${object.countWithoutWhitelisted + object.whitelistedIncidentsCount})`
                                    }
                                    else{
                                        //should not get to here but default to return name
                                        return name
                                    }
                                }
                            } catch (e) {}
                        }
                        return params.value //if we get to here then something went wrong, return zenGroupId (params.value)

                    },
                    fontSize: 11
                },
            },
            {
                type: 'number',
                position: 'left',
            },
        ],
        legend: {
            spacing: 40,
            position: 'top',
            enabled: true
        },
    }

    useEffect(() => {
        setChartIsLoading(true)
        //the data returned from this call is for the initial chart and does not include a whitelisted incident count
        incidentsPerGroupCountReactive(false).then(incidentsPerGroupList => {
            setChartIsLoading(false)
            if(incidentsPerGroupList){
                let data = []
                for (let i in incidentsPerGroupList){
                    let group = findZenGroupById(incidentsPerGroupList[i].zenGroupId)
                    if(group && group.friendlyName){
                        //found group in session
                        data.push({"zenGroupId":incidentsPerGroupList[i].zenGroupId, "zenGroupName":group.friendlyName,
                            "countWithoutWhitelisted":incidentsPerGroupList[i].countWithoutWhitelisted,
                            "whitelistedIncidentsCount":incidentsPerGroupList[i].whitelistedIncidentsCount
                        })
                    }
                    else{
                        //else did not find group in session
                        data.push({"zenGroupId":incidentsPerGroupList[i].zenGroupId,
                            "countWithoutWhitelisted":incidentsPerGroupList[i].countWithoutWhitelisted,
                            "whitelistedIncidentsCount":incidentsPerGroupList[i].whitelistedIncidentsCount
                        })
                    }
                }
                data.sort((object1, object2) => (object1.zenGroupName?.toLowerCase() > object2.zenGroupName?.toLowerCase()) ? 1 : -1)
                setChartDataWithoutWhitelistedCount(data)
            }
            else{
                setChartDataWithoutWhitelistedCount([])
            }
        }).catch(function (error) {
            setChartIsLoading(false)
        })
    }, [])

    useEffect(() => {
        //the data returned from this call is for when the user toggles to see incident count with whitelisted incidents included
        incidentsPerGroupCountReactive(true).then(incidentsPerGroupList => {
            if(incidentsPerGroupList){
                let data = []
                for (let i in incidentsPerGroupList){
                    let group = findZenGroupById(incidentsPerGroupList[i].zenGroupId)
                    if(group && group.friendlyName){
                        //found group in session
                        data.push({"zenGroupId":incidentsPerGroupList[i].zenGroupId, "zenGroupName":group.friendlyName,
                            "countWithoutWhitelisted":incidentsPerGroupList[i].countWithoutWhitelisted,
                            "whitelistedIncidentsCount":incidentsPerGroupList[i].whitelistedIncidentsCount
                        })
                    }
                    else{
                        //else did not find group in session
                        data.push({"zenGroupId":incidentsPerGroupList[i].zenGroupId,
                            "countWithoutWhitelisted":incidentsPerGroupList[i].countWithoutWhitelisted,
                            "whitelistedIncidentsCount":incidentsPerGroupList[i].whitelistedIncidentsCount
                        })
                    }
                }
                data.sort((object1, object2) => (object1.zenGroupName?.toLowerCase() > object2.zenGroupName?.toLowerCase()) ? 1 : -1)
                setChartDataWithWhitelistedCount(data)
                setIncludeWhitelistedToggleDisabled(false)
            }
            else{
                setChartDataWithWhitelistedCount([])
            }
        }).catch(function (error) {
        })
    }, [])

    const onIgnoreModalSubmit = async (data) => {
        if(selectedPaths.length < 1){
            NotificationManager.error("You must select at least one path to submit")
        }
        else{
            onWhitelistPath(data)
        }
    };
    const onSilentIncidentCreateModalSubmit = async (data) => {
        if(selectedPaths.length < 1){
            NotificationManager.error("You must select at least one path to submit")
        }
        else{
            onConfirmCreateSilentIncidents()
        }
    };

    const onWhitelistPath = async (data) => {
        try {
            if (clickedIconIncidentData && clickedIconIncidentData.zenGroupId && selectedPaths && selectedPaths.length > 0) {
                let argumentsToSend = null;
                if(whitelistModalIncludeProgramArgs && clickedIconIncidentData.programArgumentsEditedString && clickedIconIncidentData.programArgumentsEditedString.trim().length > 0){
                    argumentsToSend = clickedIconIncidentData.programArgumentsEditedString.trim();
                }
                let parentPathToSend = null
                let parentProgramArgsToSend = null
                if(whitelistModalIncludeParentPath && clickedIconIncidentData.parentPath && clickedIconIncidentData.parentPath.trim().length > 0){
                    parentPathToSend = clickedIconIncidentData.parentPath.trim()
                }
                if(whitelistModalIncludeParentProgramArgs && clickedIconIncidentData.parentProgramArgumentsString && clickedIconIncidentData.parentProgramArgumentsString.trim().length > 0){
                    parentProgramArgsToSend = clickedIconIncidentData.parentProgramArgumentsString.trim()
                }
                let onlyMatchIfTrustedCertToSend = false
                let onlyMatchIfNoInjectionsToSend = false
                let onlyMatchIfNoModifiedMemoryToSend = false
                let fileTriggersSelected = null
                if(additionalRestrictionsToggled){
                    onlyMatchIfTrustedCertToSend = onlyMatchIfTrustedCert
                    onlyMatchIfNoInjectionsToSend = onlyMatchIfNoInjections
                    onlyMatchIfNoModifiedMemoryToSend = onlyMatchIfNoModifiedMemory
                    if(newWhitelistIncidentMatchTypeList && newWhitelistIncidentMatchTypeList.length > 0){
                        fileTriggersSelected = handleFileTriggerTypesSelectedForCreateWhitelist(newWhitelistIncidentMatchTypeList)
                    }
                }
                let tempHoursToSend = 0
                if(temporaryWhitelistToggled){
                    if(data.expirationHoursNewTailoredBehavior < 1){
                        NotificationManager.error("Please Enter the Hours Until Expiration");
                        return;
                    }
                    else{
                        tempHoursToSend = data.expirationHoursNewTailoredBehavior
                    }
                }

                setIsLoading(true);
                let response = await userAddWhitelistsFromIncidentsPageReactive(selectedPaths, clickedIconIncidentData.zenGroupId, argumentsToSend, parentPathToSend, parentProgramArgsToSend,
                    onlyMatchIfTrustedCertToSend, onlyMatchIfNoInjectionsToSend, onlyMatchIfNoModifiedMemoryToSend, fileTriggersSelected, tempHoursToSend, hideCanariesToggled)
                if(response.whitelistExistedAlreadyCount > 0){
                    if(selectedPaths.length === 1){
                        //user only tried to make 1 whitelist
                        NotificationManager.info(`This tailored behavior existed already and was not created again`);
                        setIsLoading(false);
                        return
                    }
                    else{
                        //user selected more than one path to make whitelists for
                        NotificationManager.info(`${response.whitelistExistedAlreadyCount} of the tailored behaviors
                        existed already and 
                        ${response.whitelistExistedAlreadyCount > 1 ? "were" : "was"} not created`);
                        setIsLoading(false);
                        return
                    }
                }
                else{
                    NotificationManager.success("Tailored Behavior(s) added successfully");
                }
                reset({expirationHoursNewTailoredBehavior: ""})
                setShowIgnoreModal(false)
                setSuggestedPaths([])
                setSelectedPaths([])
                setIgnoreButtonDisabled(true)
            }
        } catch (error) {
            if(error.message){
                NotificationManager.error(error.message);
            }
            else{
                NotificationManager.error("Error adding tailored behavior(s)");
            }
        }
        setIsLoading(false);
        // setShowIgnoreModal(false)
    };

    const onConfirmCreateSilentIncidents =  () => {
        if(clickedIconIncidentData && clickedIconIncidentData.incidentId && selectedPaths && selectedPaths.length > 0){
            let argumentsToSend = null;
            if(clickedIconIncidentData.programArgumentsEditedString){
                argumentsToSend = clickedIconIncidentData.programArgumentsEditedString.trim();
            }
            setIsLoading(true);
            createSilentIncidentsFromIncidentsPageReactive(selectedPaths, clickedIconIncidentData.incidentId, argumentsToSend).then(response => {
                NotificationManager.success("Silent Response(s) successfully created/enabled, you may need to refresh the grid periodically to see updates for any affected responses within the same group");
                setIsLoading(false)
                reset({expirationHoursNewTailoredBehavior: ""})
                setClickedIconIncidentData()
                setShowTurnIncidentSilentModal(false)
                setSuggestedPaths([])
                setSelectedPaths([])
                refreshGrid().then()
            }).catch(function (error) {
                if(error.message){
                    NotificationManager.error(error.message);
                }
                else{
                    NotificationManager.error("Unexpected error making this request");
                }
                setIsLoading(false)
            })
        }
    }


    function resetDeleteModal(){
        setDeleteModalIsOpen(false)
        setConfirmDeleteModalIsOpen(false)
        setDeleteModalRowData(null)
    }

    function getFullGridEnabledSessionState(){
        try{
            let value = JSON.parse(decryptAndGetSessionVariable(fullGridEnabledSessionVariableName))
            if(value === null || value === undefined){
                return false
            }
            else{
                return value
            }
        } catch (e){}
        return false //return false by default
    }

    return (
        <div className="flex flex-col h-full">
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <title>Extortion Responses</title>
                <script src="https://js.stripe.com/v3/"/>
                <link href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap" rel="stylesheet"/>
            </Helmet>
            {/*Incident Details Modal*/}
            <Modal contentLabel="Response Details" isOpen={openResponseHistoryModal}
                   onRequestClose={() => {
                       setActiveIncident(null);
                       setSuggestedPaths([])
                       setSelectedPaths([])
                       setOpenResponseHistoryModal(false);
                       setClickedIconIncidentData()
                   }} shouldCloseOnOverlayClick={true}
                   className={`focus:outline-none focus:shadow-sm border-2 flex relative z-50 bg-white w-6xl max-w-6xl inset-y-10 mx-auto rounded-2xl overflow-auto`}
                   overlayClassName="z-50 bg-black bg-opacity-5 fixed inset-0 overflow-scroll"
            >
                {/*Cert Publisher Names Modal*/}
                <Modal contentLabel="Certificate Publisher Names" isOpen={showCertificateModal}
                       onRequestClose={() => {
                           setShowCertificateModal(false)
                       }} shouldCloseOnOverlayClick={true}
                       className={`focus:outline-none focus:shadow-sm border-2 flex relative z-50 bg-white max-w-xl inset-y-10 mx-auto rounded-2xl overflow-auto`}
                       overlayClassName="z-50 bg-black bg-opacity-5 fixed inset-0 overflow-scroll">

                    <div className="flex flex-1 flex-col p-8 w-full ml-4 mr-4 gap-y-5">
                        <div className="flex flex-row justify-between">
                            <h1 className="font-bold text-3xl">Certificate Publisher Names</h1>
                            <MuiCloseIconButton
                                onClick={() => {
                                    setShowCertificateModal(false)
                                }}
                            />
                        </div>
                        <hr className="h-0.5" />
                        <div className="">
                            {clickedIconIncidentData && clickedIconIncidentData.certPublisherNames && clickedIconIncidentData.certPublisherNames.length > 0 && clickedIconIncidentData.certPublisherNames.map((certName, i) => {
                                return (
                                    <div key={i} className="mb-3 ml-3 flex flex-row">
                                        {`${certName}`}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </Modal>
                {/*Cert Publisher Hashes Modal*/}
                <Modal contentLabel="Certificate Publisher Hashes" isOpen={showCertificateHashModal}
                       onRequestClose={() => {
                           setShowCertificateHashModal(false)
                       }} shouldCloseOnOverlayClick={true}
                       className={`focus:outline-none focus:shadow-sm border-2 flex relative z-50 bg-white max-w-3xl inset-y-10 mx-auto rounded-2xl overflow-auto`}
                       overlayClassName="z-50 bg-black bg-opacity-5 fixed inset-0 overflow-scroll">

                    <div className="flex flex-1 flex-col p-8 w-full ml-4 mr-4 gap-y-5">
                        <div className="flex flex-row justify-between">
                            <h1 className="font-bold text-3xl">Certificate Publisher Hashes</h1>
                            <MuiCloseIconButton
                                onClick={() => {
                                    setShowCertificateHashModal(false)
                                }}
                            />
                        </div>
                        <hr className="h-0.5" />
                        <div className="">
                            {clickedIconIncidentData && clickedIconIncidentData.certSha256Digests && clickedIconIncidentData.certSha256Digests.length > 0 && clickedIconIncidentData.certSha256Digests.map((certName, i) => {
                                return (
                                    <div key={i} className="mb-3 ml-3 flex flex-row break-all">
                                        {`${certName}`}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </Modal>
                <div className="flex flex-col w-full">
                    <div className="flex flex-row justify-between p-8">
                        <h1 className="font-bold text-3xl">Response Details</h1>
                        <MuiCloseIconButton
                            onClick={() => {
                                setActiveIncident(null);
                                setSuggestedPaths([])
                                setSelectedPaths([])
                                setOpenResponseHistoryModal(false);
                                setClickedIconIncidentData()
                            }}
                        />
                    </div>
                    <hr className="h-0.5 ml-8 mr-8" />
                    <div className="flex flex-1 flex-col p-8 w-full">
                        <DetailsGrid
                            headers={[
                                { field: "description", headerName: "Description", initialWidth: 50},
                                { field: "value", headerName: "Value"}
                            ]}
                            data={
                                clickedIconIncidentData
                                    ? processData(clickedIconIncidentData, false)
                                    : []
                            }
                            rowSelection={rowSelection}
                        />
                    </div>
                    <div className={"mx-8 mb-5 flex flex-row gap-x-3 gap-y-3 flex-wrap"}>
                        <div className="">
                            <ThemeProvider theme={buttonTheme}>
                                <Button variant={"contained"} color={"primary"}
                                        onClick={() => {
                                            setShowCertificateModal(true)
                                        }}
                                        disabled={!clickedIconIncidentData || !clickedIconIncidentData.certPublisherNames || !clickedIconIncidentData.certPublisherNames.length > 0}
                                >
                                    {(!clickedIconIncidentData || !clickedIconIncidentData.certPublisherNames || !clickedIconIncidentData.certPublisherNames.length > 0) ? "Unsigned Binary" : "View Certificate Publisher Names"}
                                </Button>
                            </ThemeProvider>
                        </div>
                        {/*We will hide this button if no hashes, so we don't have 2 unsigned binary buttons next to each other*/}
                        <div className={`${(!clickedIconIncidentData || !clickedIconIncidentData.certSha256Digests || !clickedIconIncidentData.certSha256Digests.length > 0) ? "hidden" : "visible"}`}>
                            <ThemeProvider theme={buttonTheme}>
                                <Button variant={"contained"} color={"primary"}
                                        onClick={() => {
                                            setShowCertificateHashModal(true)
                                        }}
                                        disabled={!clickedIconIncidentData || !clickedIconIncidentData.certSha256Digests || !clickedIconIncidentData.certSha256Digests.length > 0}
                                >
                                    {(!clickedIconIncidentData || !clickedIconIncidentData.certSha256Digests || !clickedIconIncidentData.certSha256Digests.length > 0) ? "Unsigned Binary" : "View Certificate Hashes"}
                                </Button>
                            </ThemeProvider>
                        </div>
                    </div>
                </div>
            </Modal>
            <InformationModal
                opened={moreInformationModalOpen}
                tailwindModalWith={"max-w-2xl"}
                onClose={() => {
                    setMoreInformationModalOpen(false)
                    setMoreInfoModalText(<div></div>)
                }}
                text={moreInfoModalText}
                contentLabel={"More Info Modal"}
            />
            {/*Ignore Modal*/}
            <Modal contentLabel="Exclude Response"
                   isOpen={showIgnoreModal}
                   onRequestClose={() => {
                       reset({expirationHoursNewTailoredBehavior: ""})
                       setShowIgnoreModal(false)
                       setSuggestedPaths([])
                       setSelectedPaths([])
                       setClickedIconIncidentData()
                       setWhitelistModalIncludeProgramArgs(false)
                       setWhitelistModalIncludeParentPath(false)
                       setWhitelistModalIncludeParentProgramArgs(false)
                       setAdditionalRestrictionsToggled(false)
                       setTemporaryWhitelistToggled(false)
                       setHideCanariesToggled(false)
                       setOnlyMatchIfTrustedCert(false)
                       setOnlyMatchIfNoInjections(false)
                       setOnlyMatchIfNoModifiedMemory(false)
                       setNewWhitelistIncidentMatchTypeList(fileTriggersToMatchAllOptions)
                   }}
                   shouldCloseOnOverlayClick={true}
                   className={`focus:outline-none focus:shadow-sm border-2 flex relative z-50 bg-white w-5xl max-w-5xl inset-y-10 mx-auto rounded-2xl overflow-auto`}
                   overlayClassName="z-50 bg-black bg-opacity-5 fixed inset-0 overflow-scroll"
            >
                <form className="flex flex-1 flex-col p-8 w-full ml-4 mr-4" onSubmit={handleSubmit(onIgnoreModalSubmit)}>
                    <div className="flex flex-1 flex-col">
                        {/*Title with exit button*/}
                        <div className="flex flex-row justify-between">
                            <h1 className="font-bold text-3xl">Exclude</h1>
                            <MuiCloseIconButton
                                onClick={() => {
                                    reset({expirationHoursNewTailoredBehavior: ""})
                                    setShowIgnoreModal(false)
                                    setSuggestedPaths([])
                                    setSelectedPaths([])
                                    setClickedIconIncidentData()
                                    setWhitelistModalIncludeProgramArgs(false)
                                    setWhitelistModalIncludeParentPath(false)
                                    setWhitelistModalIncludeParentProgramArgs(false)
                                    setAdditionalRestrictionsToggled(false)
                                    setTemporaryWhitelistToggled(false)
                                    setHideCanariesToggled(false)
                                    setOnlyMatchIfTrustedCert(false)
                                    setOnlyMatchIfNoInjections(false)
                                    setOnlyMatchIfNoModifiedMemory(false)
                                    setNewWhitelistIncidentMatchTypeList(fileTriggersToMatchAllOptions)
                                }}
                            />
                        </div>
                        <hr className="mt-3 h-0.5" />
                        {/*Form content*/}
                        <div className="flex flex-1 flex-col w-full">
                            <DetailsGrid
                                headers={[
                                    { field: "description", headerName: "Description"},
                                    { field: "value", headerName: "Value"}
                                ]}
                                data={
                                    clickedIconIncidentData
                                        ? processData(clickedIconIncidentData, true)
                                        : []
                                }
                                rowSelection={rowSelection}
                            />
                        </div>
                        <hr className="mt-3 h-0.5" />
                        <div className="ml-1 mt-5">
                            <div className="flex flex-row">
                                <label>Suggested executable paths. All selected paths will be excluded:</label>
                                {showNoSuggestedPathsFoundIcon &&
                                    <MuiIconWithTooltip
                                        icon={
                                            <FontAwesomeIcon
                                                className="ml-1 object-contain"
                                                icon="fa-light fa-circle-info"
                                                size="lg"
                                            />
                                        }
                                        tooltipTitle={"No suggested executable paths were found, you may submit this access for review if desired"}
                                        tooltipPlacement={"bottom-start"}
                                    />
                                }
                            </div>
                            {suggestedPaths && suggestedPaths.map((path) => {
                                return (
                                    <div key={path} className="ml-1 mt-5 flex flex-row">
                                        <input
                                            className="mr-2 checkbox"
                                            type="checkbox"
                                            onChange={(value) => {
                                                let selectedPathsArray = selectedPaths.slice();
                                                if(selectedPathsArray.includes(path)){
                                                    let index = selectedPathsArray.indexOf(path);
                                                    selectedPathsArray.splice(index, 1);
                                                    setSelectedPaths(selectedPathsArray);
                                                }
                                                else{
                                                    selectedPathsArray.push(path);
                                                    setSelectedPaths(selectedPathsArray);
                                                }
                                            }}
                                        />
                                        <label>{path}</label>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="flex flex-col gap-y-3 ml-1 mt-5 ">
                            <div className={`flex flex-row items-center ml-1`}>
                                <ThemeProvider theme={switchTheme}>
                                    <FormControlLabel control={
                                        <Switch
                                            checked={whitelistModalIncludeProgramArgs}
                                            disabled={!(clickedIconIncidentData && clickedIconIncidentData.programArgumentsEditedString && clickedIconIncidentData.programArgumentsEditedString.trim().length > 0)}
                                            name="whitelistModalIncludeProgramArgsToggle"
                                            onChange={e => setWhitelistModalIncludeProgramArgs(e.target.checked)}
                                        />
                                    }
                                                      label={whitelistModalIncludeProgramArgs ? "Include Program Arguments in Tailored Behaviors" : "Do Not Include Program Arguments in Tailored Behaviors"}/>
                                </ThemeProvider>
                            </div>
                            <div className={`flex flex-row items-center ml-1`}>
                                <ThemeProvider theme={switchTheme}>
                                    <FormControlLabel control={
                                        <Switch
                                            checked={whitelistModalIncludeParentPath}
                                            disabled={!(clickedIconIncidentData && clickedIconIncidentData.parentPath && clickedIconIncidentData.parentPath.trim().length > 0)}
                                            name="whitelistModalIncludeParentPathToggle"
                                            onChange={e => setWhitelistModalIncludeParentPath(e.target.checked)}
                                        />
                                    }
                                                      label={whitelistModalIncludeParentPath ? "Include Parent Program Path in Tailored Behaviors" : "Do Not Include Parent Program Path in Tailored Behaviors"}/>
                                </ThemeProvider>
                            </div>
                            <div className={`flex flex-row items-center ml-1`}>
                                <ThemeProvider theme={switchTheme}>
                                    <FormControlLabel control={
                                        <Switch
                                            checked={whitelistModalIncludeParentProgramArgs}
                                            disabled={!(clickedIconIncidentData && clickedIconIncidentData.parentProgramArgumentsString && clickedIconIncidentData.parentProgramArgumentsString.trim().length > 0)}
                                            name="whitelistModalIncludeParentProgramArgsToggle"
                                            onChange={e => setWhitelistModalIncludeParentProgramArgs(e.target.checked)}
                                        />
                                    }
                                                      label={whitelistModalIncludeParentProgramArgs ? "Include Parent Program Arguments in Tailored Behaviors" : "Do Not Include Parent Program Arguments in Tailored Behaviors"}/>
                                </ThemeProvider>
                            </div>
                            <div className={`flex flex-row items-center ml-1`}>
                                <ThemeProvider theme={switchTheme}>
                                    <FormControlLabel control={
                                        <Switch
                                            checked={additionalRestrictionsToggled}
                                            name="newWhitelistAdditionalRestrictionsToggled"
                                            onChange={e => setAdditionalRestrictionsToggled(e.target.checked)}
                                        />
                                    }
                                                      label={additionalRestrictionsToggled ? "Enter Additional Tailored Behavior Restrictions" : "Do Not Enter Additional Tailored Behavior Restrictions"}/>
                                </ThemeProvider>
                            </div>
                            <div
                                className={`${additionalRestrictionsToggled ? "block ml-3" : "hidden"} flex flex-row items-center`}>
                                <ThemeProvider theme={switchTheme}>
                                    <FormControlLabel control={
                                        <Switch
                                            checked={onlyMatchIfTrustedCert}
                                            name="newWhitelistOnlyMatchIfTrustedCertToggle"
                                            onChange={e => setOnlyMatchIfTrustedCert(e.target.checked)}
                                        />
                                    }
                                                      label={onlyMatchIfTrustedCert ? "Only Match Tailored Behavior if Trusted Cert" : "Do Not Limit Tailored Behavior to Match Trusted Certs Only"}/>
                                </ThemeProvider>
                                <MuiIconWithTooltip
                                    icon={
                                        <FontAwesomeIcon
                                            className="object-contain mt-1 cursor-pointer"
                                            icon="fa-light fa-circle-info"
                                            size="lg"
                                        />
                                    }
                                    tooltipTitle={`This setting controls whether the tailored behavior should be applied to an extortion response regardless of if the response has a trusted cert or not, or only apply the 
                                tailored behavior when the extortion response has a trusted cert (meaning the response will be suspended otherwise). The default setting is to not limit.`}
                                    tooltipPlacement={"bottom-start"}
                                />
                            </div>
                            <div
                                className={`${additionalRestrictionsToggled ? "block ml-3" : "hidden"} flex flex-row items-center`}>
                                <ThemeProvider theme={switchTheme}>
                                    <FormControlLabel control={
                                        <Switch
                                            checked={onlyMatchIfNoInjections}
                                            name="newWhitelistOnlyMatchIfNoInjectionsToggle"
                                            onChange={e => setOnlyMatchIfNoInjections(e.target.checked)}
                                        />
                                    }
                                                      label={onlyMatchIfNoInjections ? "Only Match Tailored Behavior if No Related Injections" : "Do Not Limit Tailored Behavior to Match No Related Injections Only"}/>
                                </ThemeProvider>
                                <MuiIconWithTooltip
                                    icon={
                                        <FontAwesomeIcon
                                            className="object-contain mt-1 cursor-pointer"
                                            icon="fa-light fa-circle-info"
                                            size="lg"
                                        />
                                    }
                                    tooltipTitle={`This setting controls if the tailored behavior should be applied to an extortion response regardless of if the response has related process injections or not, or only apply the
                                tailored behavior when the extortion response has no related process injections (meaning the response will be suspended otherwise). The default setting is to not limit.`}
                                    tooltipPlacement={"bottom-start"}
                                />
                            </div>
                            <div
                                className={`${additionalRestrictionsToggled ? "block ml-3" : "hidden"} flex flex-row items-center`}>
                                <ThemeProvider theme={switchTheme}>
                                    <FormControlLabel control={
                                        <Switch
                                            checked={onlyMatchIfNoModifiedMemory}
                                            name="newWhitelistOnlyMatchIfNoModifiedMemoryToggle"
                                            onChange={e => setOnlyMatchIfNoModifiedMemory(e.target.checked)}
                                        />
                                    }
                                                      label={onlyMatchIfNoModifiedMemory ? "Only Match Tailored Behavior if No Modified Memory" : "Do Not Limit Tailored Behavior to Match No Modified Memory Only"}/>
                                </ThemeProvider>
                                <MuiIconWithTooltip
                                    icon={
                                        <FontAwesomeIcon
                                            className="object-contain mt-1 cursor-pointer"
                                            icon="fa-light fa-circle-info"
                                            size="lg"
                                        />
                                    }
                                    tooltipTitle={`This setting controls if the tailored behavior should be applied to an extortion response regardless of if the response has modified memory or not, or only apply the
                                tailored behavior when the extortion response has no modified memory (meaning the response will be suspended otherwise). The default setting is to not limit.`}
                                    tooltipPlacement={"bottom-start"}
                                />
                            </div>
                            <div className={`${additionalRestrictionsToggled ? "block ml-3" : "hidden"}`}>
                                <label>File Triggers To Match</label>
                                <MuiAutocompleteNonGroupOptions
                                    options={fileTriggersToMatchAllOptions}
                                    multiple={true}
                                    label={"All Triggers Used by Default"}
                                    value={newWhitelistIncidentMatchTypeList}
                                    onChange={(event, valueList) => {
                                        setNewWhitelistIncidentMatchTypeList(valueList)
                                    }}
                                />
                            </div>
                            <div className={`flex flex-row items-center ml-1`}>
                                <ThemeProvider theme={switchTheme}>
                                    <FormControlLabel control={
                                        <Switch
                                            checked={temporaryWhitelistToggled}
                                            name="addWhitelistFromIncidentsPageTemporaryWhitelistToggled"
                                            onChange={e => setTemporaryWhitelistToggled(e.target.checked)}
                                        />
                                    } label={temporaryWhitelistToggled ? "Make Tailored Behaviors Temporary" : "Make Tailored Behaviors Permanent"}/>
                                </ThemeProvider>
                            </div>
                            <div className={`${temporaryWhitelistToggled ? "block ml-3" : "hidden"}`}>
                                <div className="flex flex-row items-center gap-x-3 gap-y-2 flex-wrap">
                                    <label>Hours Until Expiration</label>
                                    <input
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter' || e.key === "e" || e.key === "-" || e.key === "+" || e.key === ".") {
                                                e.preventDefault();
                                            }
                                        }}
                                        min={0} max={168} type="number"
                                        autoComplete="off"
                                        name="expirationHoursNewTailoredBehavior"
                                        {...register("expirationHoursNewTailoredBehavior")}
                                        className="text-center w-24 focus:outline-none h-10 p-1 rounded-lg border border-black border-opacity-25 border-solid"
                                    />
                                </div>
                            </div>
                            <div className={`flex flex-row items-center ml-1`}>
                                <ThemeProvider theme={switchTheme}>
                                    <FormControlLabel control={
                                        <Switch
                                            checked={hideCanariesToggled}
                                            name="newHideCanariesWhitelistToggled"
                                            onChange={e => setHideCanariesToggled(e.target.checked)}
                                        />
                                    }
                                                      label={hideCanariesToggled ? "Deception data will be hidden" : "Deception data will be shown"}/>
                                </ThemeProvider>
                            </div>
                        </div>
                        <div className="ml-1 mt-5 flex flex-row flex-wrap items-center gap-x-3 gap-y-3">
                            <label>Not seeing what you need?</label>
                            <Link to={{pathname: "/private/tailoredBehaviors"}} state={{
                                showCreateModalV2: true,
                                path: clickedIconIncidentData ? clickedIconIncidentData.path?.trim() : null,
                                parentPath: clickedIconIncidentData ? clickedIconIncidentData.parentPath?.trim() : null,
                                zenGroupId: clickedIconIncidentData ? clickedIconIncidentData.zenGroupId : null,
                                programArguments: clickedIconIncidentData ? clickedIconIncidentData.programArgumentsEditedString?.trim() : null,
                                parentProgramArguments: clickedIconIncidentData ? clickedIconIncidentData.parentProgramArgumentsString?.trim() : null
                            }} className="mr-2">
                                <ThemeProvider theme={roundButtonTheme}>
                                    <Button variant={"contained"} color={"secondary"}>
                                    Take me to Tailored Behaviors Page
                                    </Button>
                                </ThemeProvider>
                            </Link>
                            <ThemeProvider theme={roundButtonTheme}>
                                <Button variant={"contained"} color={"secondary"}
                                        onClick={async () => {
                                            if (clickedIconIncidentData && clickedIconIncidentData.incidentId) {
                                                try {
                                                    setIsLoading(true)
                                                    await submitIncidentForReviewReactive(clickedIconIncidentData.incidentId)
                                                    NotificationManager.success("Successfully submitted this response for review")
                                                    reset({expirationHoursNewTailoredBehavior: ""})
                                                    setShowIgnoreModal(false)
                                                    setSuggestedPaths([])
                                                    setSelectedPaths([])
                                                    setIgnoreButtonDisabled(true)
                                                    setClickedIconIncidentData()
                                                } catch (error) {
                                                    if (error.message) {
                                                        NotificationManager.error(error.message);
                                                    } else {
                                                        NotificationManager.error("Error submitting this response for review")
                                                    }
                                                }
                                                setIsLoading(false)
                                            }
                                        }}
                                >
                                    Submit Response for Review
                                </Button>
                            </ThemeProvider>
                        </div>
                        <div className="flex flex-1 flex-col mt-5">
                        <ThemeProvider theme={buttonTheme}>
                            <Button
                                variant={"contained"}
                                color={"primary"}
                                type={"submit"}
                                disabled={ignoreSubmitButtonDisabled}
                            >
                                Submit
                            </Button>
                        </ThemeProvider>
                        </div>
                    </div>

                </form>
            </Modal>
            {/*Turn Incident to Silent Modal*/}
            <Modal contentLabel="Silent Response"
                   isOpen={showTurnIncidentSilentModal}
                   onRequestClose={() => {
                       reset({expirationHoursNewTailoredBehavior: ""})
                       setShowTurnIncidentSilentModal(false)
                       setSuggestedPaths([])
                       setSelectedPaths([])
                       setClickedIconIncidentData()
                   }}
                   shouldCloseOnOverlayClick={true}
                   className={`focus:outline-none focus:shadow-sm border-2 flex relative z-50 bg-white w-3xl max-w-4xl inset-y-10 mx-auto rounded-2xl overflow-auto`}
                   overlayClassName="z-50 bg-black bg-opacity-5 fixed inset-0 overflow-scroll"
            >
                <form className="flex flex-1 flex-col p-8 w-full ml-4 mr-4" onSubmit={handleSubmit(onSilentIncidentCreateModalSubmit)}>
                    <div className="flex flex-1 flex-col">
                        {/*Title with exit button*/}
                        <div className="flex flex-row justify-between">
                            <h1 className="font-bold text-3xl">Silence Response</h1>
                            <MuiCloseIconButton
                                onClick={() => {
                                    reset({expirationHoursNewTailoredBehavior: ""})
                                    setShowTurnIncidentSilentModal(false)
                                    setSuggestedPaths([])
                                    setSelectedPaths([])
                                    setClickedIconIncidentData()
                                }}
                            />
                        </div>
                        <hr className="mt-3 h-0.5" />
                        {/*Form content*/}
                        <div className="ml-1 mt-5">
                            <div><label>Response Name:</label>{` ${(clickedIconIncidentData && clickedIconIncidentData.incidentDisplayName) ? clickedIconIncidentData.incidentDisplayName : ""}`}</div>
                        </div>
                        <div className="ml-1 mt-5">
                            <div><label>Program Path:</label>{` ${(clickedIconIncidentData && clickedIconIncidentData.path) ? clickedIconIncidentData.path : ""}`}</div>
                        </div>
                        <div className="ml-1 mt-5">
                            <div><label>Program Arguments:</label>{` ${(clickedIconIncidentData && clickedIconIncidentData.programArgumentsEditedString) ? clickedIconIncidentData.programArgumentsEditedString : ""}`}</div>
                        </div>
                        <hr className="mt-3 h-0.5" />
                        <div className="ml-1 mt-5">
                            <div className="flex flex-row">
                            <label>Suggested executable paths. All selected paths will be silenced:
                            </label>
                                {showNoSuggestedSilentIncidentPathsFoundIcon &&
                                    <MuiIconWithTooltip
                                        icon={
                                            <FontAwesomeIcon
                                                className="ml-1 object-contain"
                                                icon="fa-light fa-circle-info"
                                                size="lg"
                                            />
                                        }
                                        tooltipTitle={`No suggested executable paths were found. You may click the "Take me to Silent Responses Page" button that will redirect you to the
                                        Silent Responses page. This will also automatically supply the create new Silent Response form with the response's group, path, and
                                        program arguments (if present).`}
                                        tooltipPlacement={"bottom-start"}
                                    />
                                }
                            </div>
                            {suggestedPaths && suggestedPaths.map((path) => {
                                return (
                                    <div key={path} className="ml-1 mt-5 flex flex-row">
                                        <input
                                            className="mr-2 checkbox"
                                            type="checkbox"
                                            onChange={(value) => {
                                                let selectedPathsArray = selectedPaths.slice();
                                                if(selectedPathsArray.includes(path)){
                                                    let index = selectedPathsArray.indexOf(path);
                                                    selectedPathsArray.splice(index, 1);
                                                    setSelectedPaths(selectedPathsArray);
                                                }
                                                else{
                                                    selectedPathsArray.push(path);
                                                    setSelectedPaths(selectedPathsArray);
                                                }
                                            }}
                                        />
                                        <label>{path}</label>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="ml-1 mt-5 flex flex-row flex-wrap items-center gap-x-3 gap-y-3">
                            <label>Not seeing what you need?</label>
                            <div className="mt-2">
                                <MuiIconWithTooltip
                                    icon={
                                        <FontAwesomeIcon
                                            className="ml-1 object-contain"
                                            icon="fa-light fa-circle-info"
                                            size="lg"
                                        />
                                    }
                                    tooltipTitle={"Clicking this button will redirect you to the Silent Responses page and automatically supply the create new Silent\n" +
                                        "                                                    Response form with the response's group, path, and program arguments (if present)."}
                                    tooltipPlacement={"bottom-start"}
                                />
                            </div>
                            <Link to={{pathname:"/private/silentResponses"}} state={{showCreateModal: true,
                                path: clickedIconIncidentData ? clickedIconIncidentData.path?.trim() : null,
                                zenGroupId: clickedIconIncidentData ? clickedIconIncidentData.zenGroupId : null,
                                programArguments: clickedIconIncidentData ? clickedIconIncidentData.programArgumentsEditedString?.trim() : null
                            }} className="mr-2">
                                <ThemeProvider theme={roundButtonTheme}>
                                    <Button variant={"contained"} color={"secondary"}>
                                        Take me to Silent Responses Page
                                    </Button>
                                </ThemeProvider>
                            </Link>
                        </div>
                        <div className="flex flex-1 flex-col mt-5">
                            <ThemeProvider theme={buttonTheme}>
                                <Button variant={"contained"} color={"primary"}
                                        type={"submit"}
                                    disabled={silentIncidentTurnOnModalButtonDisabled}
                                >
                                Submit
                                </Button>
                            </ThemeProvider>
                        </div>
                    </div>

                </form>
            </Modal>
            <Modal contentLabel="Delete Program" isOpen={deleteModalIsOpen}
                   onRequestClose={() => {
                       resetDeleteModal()
                   }} shouldCloseOnOverlayClick={true}
                   className={`focus:outline-none focus:shadow-sm border-2 flex relative z-50 bg-white w-6xl max-w-6xl inset-y-10 mx-auto rounded-2xl overflow-auto`}
                   overlayClassName="z-50 bg-black bg-opacity-5 fixed inset-0 overflow-scroll"
            >
                <ConfirmationModal
                    text={`This action is irreversible and cannot be cancelled. Confirm you would like to delete this program.`}
                    onConfirm={() => {
                        if(deleteModalRowData && deleteModalRowData.incidentId){
                            setIsLoading(true)
                            deleteIncidentProgramReactive(deleteModalRowData.incidentId).then(response => {
                                setIsLoading(false)
                                NotificationManager.success("Successfully queued the deletion")
                                resetDeleteModal()
                            }).catch(function (error) {
                                setIsLoading(false)
                                if(error.message){
                                    NotificationManager.error(error.message);
                                }
                                else{
                                    NotificationManager.error("Unexpected error completing this request.");
                                }
                            })
                        }
                    }}
                    onClose={() => {
                        setConfirmDeleteModalIsOpen(false);
                    }}
                    opened={confirmDeleteModalIsOpen}
                />
                <div className="flex flex-col w-full gap-y-5 p-8">
                    <div className="flex flex-row justify-between">
                        <h1 className="font-bold text-3xl">Delete Program</h1>
                        <MuiCloseIconButton
                            onClick={() => {
                                resetDeleteModal()
                            }}
                        />
                    </div>
                    <hr className="h-0.5"/>
                    <div className="">
                        <label className="text-xl">Response Details:</label>
                    </div>
                    <div className="flex flex-1 flex-col w-full">
                        <DetailsGrid
                            headers={[
                                {field: "description", headerName: "Description", initialWidth: 50},
                                {field: "value", headerName: "Value"}
                            ]}
                            rowSelection={rowSelection}
                            data={deleteModalRowData ? processData(deleteModalRowData) : []}
                        />
                    </div>
                    <hr className="h-0.5"/>
                    <div className="flex flex-row break-all">
                        <div><label className={"font-bold break-normal"}>Program to Delete: </label>{deleteModalRowData && deleteModalRowData.path}</div>
                    </div>
                    <div className="flex flex-row">
                        <div><label className={"font-bold"}>WARNING:</label> Deleting this program is irreversible and cannot be cancelled after confirming, use with caution.</div>
                    </div>
                    <div className="">
                        <ThemeProvider theme={buttonTheme}>
                            <Button variant={"contained"} color={"primary"}
                                    onClick={() => {
                                        setConfirmDeleteModalIsOpen(true)
                                    }}
                            >
                                Delete Program
                            </Button>
                        </ThemeProvider>
                    </div>
                </div>
            </Modal>
            <BrowserUtilityProcessTuningModal tuningModalIsOpen={tuningModalIsOpen}
                                              setTuningModalIsOpen={setTuningModalIsOpen} setIsLoading={setIsLoading}
                                              initialZenGroup={zenGroupForTuningModal}/>
            <div className="flex flex-1 flex-col flex-nowrap gap-y-3 h-full">
                    {privatePageHeaderHelper("Extortion Responses")}
                    <hr className="h-0.5" />
                    <DisplayOptions useFilterStateSettingToggled={useFilterStateSettingToggled}
                                    setUseFilterStateSettingToggled={setUseFilterStateSettingToggled}
                                    toggleUpdateUseFilterState={toggleUpdateUseFilterState}
                                    useColumnStateSettingToggled={useColumnStateSettingToggled}
                                    setUseColumnStateSettingToggled={setUseColumnStateSettingToggled}
                                    toggleUpdateUseColumnState={toggleUpdateUseColumnState}
                                    fullGridToggled={fullGridToggled}
                                    setFullGridToggled={setFullGridToggled}
                                    fullGridEnabledSessionVariableName={fullGridEnabledSessionVariableName}
                                    updateFullIncidentGridEnabledReactive={updateFullIncidentGridEnabledReactive}
                                    chartToggled={chartToggled}
                                    setChartToggled={setChartToggled}
                                    chartSessionVariableName={chartSessionVariableName}
                                    updateChartVisibilitySettingInSession={updateChartVisibilitySettingInSession}
                                    updateChartVisibilityReactive={updateDataIncidentChartVisibilityReactive}
                                    includeWhitelistedToggled={includeWhitelistedToggled}
                                    setIncludeWhitelistedToggled={setIncludeWhitelistedToggled}
                                    includeWhitelistedToggleDisabled={includeWhitelistedToggleDisabled}
                                    chartName={"Metrics"}

                    />
                    {/*Incidents Chart*/}
                    <div className={`chartContainer ${chartToggled ? `block` : `hidden`} relative`}>
                        <AgChartsReact options={
                            !includeWhitelistedToggled ? chartWithoutWhitelistedCountOptions : chartWithWhitelistedCountOptions
                        } />
                        <BackDropChartLoadingOverlay opened={chartIsLoading} />
                    </div>
                    <div className="flex flex-row justify-between gap-x-1 gap-y-3">
                        <div className={"self-end flex flex-col gap-y-0"}>
                        </div>
                        {/** For parent/child grid **/}
                        <div className={`${fullGridToggled ? "hidden" : "block"} flex flex-row flex-wrap gap-y-3 gap-x-8 self-end justify-end items-center`}>
                            <ClickToShowColumnOptionsWithToggleButtonGroup
                                columnMode={columnMode} setColumnMode={setColumnMode} gridColumnStateSessionVariableName={gridColumnStateSessionVariableName} gridApi={gridApi}
                                minColumnIds={minColumnIds} medColumnIds={medColumnIds} updateGridColumnModeFunction={updateIncidentsGridColumnModeReactive} />
                            <div className={"mr-2"}>
                                <ClearRefresh gridApi = {gridApi}
                                              refreshGridFunction = {refreshGrid} showRefreshIcon={false}/>
                            </div>
                        </div>
                        {/** For full col grid **/}
                        <div className={`${fullGridToggled ? "block" : "hidden"} flex flex-row flex-wrap gap-y-3 gap-x-8 self-end justify-end items-center`}>
                            <ClickToShowColumnOptionsWithToggleButtonGroup
                                columnMode={fullGridColumnMode} setColumnMode={setFullGridColumnMode} gridColumnStateSessionVariableName={fullGridColumnStateSessionVariableName} gridApi={fullGridApi}
                                minColumnIds={minColumnIds} medColumnIds={medColumnIds} updateGridColumnModeFunction={null} />
                            <div className={"mr-2"}>
                                <ClearRefresh gridApi = {fullGridApi}
                                              refreshGridFunction = {refreshGrid} showRefreshIcon={false}/>
                            </div>
                        </div>
                    </div>
                    <div className={`${fullGridToggled ? "hidden" : "block"} h-full flex flex-col gap-y-5`} id="parentChildGridRoot">
                        {getGrid(false)}
                    </div>
                    <div className={`${fullGridToggled ? "block" : "hidden"} h-full flex flex-col gap-y-5`} id="fullGridRoot">
                        {getGrid(true)}
                    </div>
                </div>
        </div>
    );

    function toggleUpdateUseFilterState(toggleSetting){
        updateUseFilterStateHelper(toggleSetting, 'incidentsGridFilterState', updateIncidentsGridUseFilterStateReactive);
    }

    function toggleUpdateUseColumnState(toggleSetting){
        updateUseColumnStateHelper(toggleSetting, gridColumnStateSessionVariableName, updateIncidentsGridUseColumnStateReactive);
    }

    function initializeWhitelistModalForIconClick(incidentData){
        setSelectedPaths([])
        setClickedIconIncidentData(incidentData)
        setIgnoreSubmitButtonDisabled(false)
        setShowNoSuggestedPathsFoundIcon(false)
        setWhitelistModalIncludeProgramArgs(false)
        setWhitelistModalIncludeParentPath(false)
        setWhitelistModalIncludeParentProgramArgs(false)
        setNewWhitelistIncidentMatchTypeList(fileTriggersToMatchAllOptions)
        setAdditionalRestrictionsToggled(false)
        setTemporaryWhitelistToggled(false)
        setHideCanariesToggled(false)
        setOnlyMatchIfTrustedCert(false)
        setOnlyMatchIfNoInjections(false)
        setOnlyMatchIfNoModifiedMemory(false)
        //load suggested paths and programArgs
        findSuggestedPathsReactive(incidentData?.path).then(response => {
            if(response.suggestedPaths && response.suggestedPaths.length > 0){
                setSuggestedPaths(response.suggestedPaths)
            }
            else{
                setSuggestedPaths([])
                setIgnoreSubmitButtonDisabled(true)
                setShowNoSuggestedPathsFoundIcon(true)
            }
        }).catch(function (error) {
            setSuggestedPaths([])
            setIgnoreSubmitButtonDisabled(true)
            setShowNoSuggestedPathsFoundIcon(true)
        })
        setShowIgnoreModal(true)
    }

    function initializeDetailsModalForIconClick(incidentData){
        setClickedIconIncidentData(incidentData)
        setOpenResponseHistoryModal(true)
    }

    function initializeDeleteModalForIconClick(incidentData){
        resetDeleteModal()
        setDeleteModalIsOpen(true)
        setDeleteModalRowData(incidentData)
    }

    function initializeTurnSilentSettingToOffForIconClick(incidentData){
        //setClickedIconIncidentData(incidentData)
        if(incidentData && incidentData.incidentId){
            userSetIncidentAsNotSilentReactive(incidentData.incidentId).then(response => {
                NotificationManager.success("Successfully queued update, you may need to refresh the grid periodically to see updates for any affected responses within the same group")
                setClickedIconIncidentData()
                refreshGrid().then()
            }).catch(function (error) {
                if(error.message){
                    NotificationManager.error(error.message);
                }
                else{
                    NotificationManager.error("Unexpected error completing this request.");
                }
            })
        }
    }

    function initializeTurnSilentSettingToOnForIconClick(incidentData){
        //mirroring this program arguments replacement, don't think we need to do this though
        let data = incidentData
        let programArgumentsString = ""
        let parentProgramArgumentsString = ""
        if(data) {
            programArgumentsString = removePathFromStartOfProgramArgumentsHelper(data.path, data.programArguments)
            parentProgramArgumentsString = removePathFromStartOfProgramArgumentsHelper(data.parentPath, data.parentProgramArguments)
        }

        data.programArgumentsEditedString = programArgumentsString
        data.parentProgramArgumentsString = parentProgramArgumentsString
        setClickedIconIncidentData(data)
        setShowNoSuggestedSilentIncidentPathsFoundIcon(false)
        setSilentIncidentTurnOnModalButtonDisabled(false)
        setSelectedPaths([])
        findSuggestedSilentIncidentPathsReactive(incidentData.path, incidentData.incidentId).then(suggestedPaths => {
            if(suggestedPaths && suggestedPaths.length > 0){
                setSuggestedPaths(suggestedPaths)
            }
            else{
                setSuggestedPaths([])
                setSilentIncidentTurnOnModalButtonDisabled(true)
                setShowNoSuggestedSilentIncidentPathsFoundIcon(true)
            }
        }).catch(function (error) {
            setSuggestedPaths([])
            setSilentIncidentTurnOnModalButtonDisabled(true)
            setShowNoSuggestedSilentIncidentPathsFoundIcon(true)
        })
        setShowTurnIncidentSilentModal(true)
    }

    function getGrid(gridWithAllColumns){
        return (
            <Grid
                onClickRow={(data) => {
                    //setActiveIncident(data[0])
                }}
                initialGridColumnDefs={gridWithAllColumns ? fullGridInitialColumnDefs : parentChildInitialGridColumnDefs}
                defaultColDef={defaultColDef}
                sideBar={sideBar}
                rowSelection={rowSelection}
                detailRowHeight={detailRowHeight}
                setDetailRowHeight={setDetailRowHeight}
                setGridApi={gridWithAllColumns ? setFullGridApi : setGridApi}
                initializeWhitelistModalForIconClick={initializeWhitelistModalForIconClick}
                initializeDetailsModalForIconClick={initializeDetailsModalForIconClick}
                initializeTurnSilentSettingToOnForIconClick={initializeTurnSilentSettingToOnForIconClick}
                initializeTurnSilentSettingToOffForIconClick={initializeTurnSilentSettingToOffForIconClick}
                initializeDeleteModalForIconClick={initializeDeleteModalForIconClick}
                columnMode={gridWithAllColumns ? fullGridColumnMode : columnMode}
                setColumnMode={gridWithAllColumns ? setFullGridColumnMode : setColumnMode}
                incidentLocation={incidentLocation}
                gridWithAllColumns={gridWithAllColumns}
                setFullGridToggled={setFullGridToggled}
            />
        );
    }

    async function refreshGrid(){
        return
        /*
        await refreshGridZenGroupAndAgentInformation(gridApi, "incidentId", "id", findByIncidentIdListReactive,
            keysToRefresh, "agentId",null, true)
        gridApi && gridApi.refreshCells({columns: ["hidingRule"], suppressFlash: true, force: true})

         */
    }

    function checkChromeProgramArgumentsForTuningModal(programArgumentsDecoded){
        let showTuningModal = false
        if(programArgumentsDecoded !== null && programArgumentsDecoded !== undefined && programArgumentsDecoded.trim().length > 0){
            chromeUtilityArgsToShowTuningModal.forEach(args => {
                if(programArgumentsDecoded.toLowerCase().includes(args.toLowerCase())){
                    showTuningModal = true
                }
            })
        }
        return showTuningModal
    }


}

let saveFilterChanges = true //If user clicks link from data incident notification and is redirected to data incidents page, we don't want to save filters
class Grid extends Component {
    constructor(props, onClickRow, filterVals) {
        super(props);
    }
    onFirstDataRendered = (params) => {

    };
    onCellValueChanged = (event) => {
        //console.log("cell change old value: "+event.oldValue+" and new value "+event.newValue);
    }
    onColumnStateChanged = (params) => {
        //function to handle when column state changes: sort change, column visibility changes, or a column position on grid is moved
        let fullGridColumnsEnabled = this.props.gridWithAllColumns
        let apiFunctionToUse = fullGridColumnsEnabled ? null : updateIncidentsGridColumnStateReactive
        let apiColumnModeFunctionToUse = fullGridColumnsEnabled ? null : updateIncidentsGridColumnModeReactive
        let varNameToUse = fullGridColumnsEnabled ? fullGridColumnStateSessionVariableName : gridColumnStateSessionVariableName
        if(params.source !== "api" && params.source !== "gridOptionsChanged"){
            this.props.setColumnMode && this.props.setColumnMode(customColumnModeText)
            onColumnStateChangedHelper(params, varNameToUse, apiFunctionToUse)
            updateColumnModeInSessionHelper(varNameToUse, apiColumnModeFunctionToUse, customColumnModeText)
        }
        else if(params.source === "api" && params.type === "sortChanged"){
            this.props.setColumnMode && this.props.setColumnMode(customColumnModeText)
            onColumnStateChangedHelper(params, varNameToUse, apiFunctionToUse)
            updateColumnModeInSessionHelper(varNameToUse, apiColumnModeFunctionToUse, customColumnModeText)
        }
    }
    getContextMenuItems = (params) => {
        return [
            "resetColumns",
            "autoSizeAll"
        ];
    };
    onGridReady = async (gridReadyParams) => {
        // Disable text selection on the page while holding shift or control (to allow grid selections to be done easily without selecting all text)
        ["keyup","keydown"].forEach((event) => {
            window.addEventListener(event, (e) => {
                document.onselectstart = function() {
                    return !(e.shiftKey || e.ctrlKey);
                }
            });
        });
        let fullGridColumnsEnabled = this.props.gridWithAllColumns
        //check if we want to apply saved column state

        //Only max/custom are allowed for this grid
        let columnMode = this.props.columnMode
        //check which initial column mode to apply
        let apiColumnModeFunctionToUse = fullGridColumnsEnabled ? null : updateIncidentsGridColumnModeReactive
        let varNameToUse = fullGridColumnsEnabled ? fullGridColumnStateSessionVariableName : gridColumnStateSessionVariableName
        if(columnMode === customColumnModeText){
            onGridReadyHelperForColumnStateForIncidentsGrid(gridReadyParams, varNameToUse)
        }
        else if(columnMode === minColumnModeText){
            standardApplyMinimumOrMediumColumnMode(varNameToUse, gridReadyParams.api, this.props.setColumnMode, minColumnModeText, minColumnIds, apiColumnModeFunctionToUse)
        }
        else if(columnMode === mediumColumnModeText){
            standardApplyMinimumOrMediumColumnMode(varNameToUse, gridReadyParams.api, this.props.setColumnMode, mediumColumnModeText, medColumnIds, apiColumnModeFunctionToUse)
        }
        //else if columnMode is max then the default column state already shows the max amount of columns no need to update

        let filterForNotification = false
        saveFilterChanges = true //reset to true
        if(this.props.incidentLocation && this.props.incidentLocation.state){
            let loginURLSearchParams = this.props.incidentLocation.state.loginURLSearchParams
            let fullDataIncidentFilterCriteriaURLSearchParamsEncoded = this.props.incidentLocation.state.fullDataIncidentFilterCriteria
            if(loginURLSearchParams !== null && loginURLSearchParams !== undefined && loginURLSearchParams.trim().length > 0){
                //call to get the notification with loginURLSearchParams
                try{
                    let response = await findNotificationEventForDataIncidentAutoFilter(loginURLSearchParams)

                    let zenGroupId = response.zenGroupId
                    let zenGroup = findZenGroupById(zenGroupId)
                    let queryStartDateMillis = response.queryStartDateMillis
                    let queryEndDateMillis = response.queryEndDateMillis
                    let sendAlertsForSilentIncidents = response.sendAlertsForSilentIncidents
                    if(zenGroupId && queryStartDateMillis && queryEndDateMillis && zenGroup && zenGroup.friendlyName){
                        let startFilterString = getDateStringForAgGridFilter(queryStartDateMillis, null, true)
                        let endFilterString = getDateStringForAgGridFilter(queryEndDateMillis)
                        if(startFilterString && endFilterString){
                            //build filter to apply to grid
                            filterForNotification = true
                            saveFilterChanges = false //don't save filter changes for when we auto filter
                            this.props.setFullGridToggled && this.props.setFullGridToggled(false) //show old parent/child grid since thats how the service works for security alert
                            let filter = {}
                            filter["zenGroupDisplayName"] = {
                                "values": [
                                    zenGroup.friendlyName
                                ],
                                "filterType": "set"
                            }
                            filter["dateCreatedRounded"] = {
                                "dateFrom": startFilterString,
                                "dateTo": endFilterString,
                                "filterType": "date",
                                "type": "inRange"
                            }
                            //Don't filter for non-silent only because at time of notification sendAlertsForSilentIncidents could be false and then after the user silences incident, which means the incident will
                            // not appear if we include the filter below
                            /*let silentFilterObject = {}
                            if(!sendAlertsForSilentIncidents){
                                //if sendAlertsForSilentIncidents is false then we want to apply the default silent filter like we would normally
                                silentFilterObject = {
                                    "values": [
                                        "Not Silent"
                                    ],
                                    "filterType": "set"
                                }
                            }*/
                            filter["whitelistAppliedId"] = {
                                "filterType": "multi",
                                "filterModels": [
                                    {
                                        "values": [
                                            "Not Excluded"
                                        ],
                                        "filterType": "set"
                                    }
                                ]
                            }
                            //apply filter model
                            gridReadyParams.api.setFilterModel(filter);
                        }
                    }
                } catch (e) {}
            }
            else if(fullDataIncidentFilterCriteriaURLSearchParamsEncoded !== null && fullDataIncidentFilterCriteriaURLSearchParamsEncoded !== undefined && fullDataIncidentFilterCriteriaURLSearchParamsEncoded.trim().length > 0){
                try{
                    //We are coming from SIEM tool (Sentinel), the decoded url param will be an object with each key containing the encoded filter value
                    let fullDataIncidentFilterCriteriaURLSearchParams = JSON.parse(atob(fullDataIncidentFilterCriteriaURLSearchParamsEncoded))
                    let groupIdEncoded = fullDataIncidentFilterCriteriaURLSearchParams.groupIdEncoded
                    let machineEncoded = fullDataIncidentFilterCriteriaURLSearchParams.machineEncoded
                    let dateCreatedRoundedEncoded = fullDataIncidentFilterCriteriaURLSearchParams.dateCreatedRoundedEncoded
                    if(groupIdEncoded && machineEncoded && dateCreatedRoundedEncoded){
                        //At the very least, we need these fields above to continue with filter
                        let zenGroupId = atob(groupIdEncoded)
                        let zenGroup = findZenGroupById(zenGroupId)
                        let dateCreatedRoundedDecodedString = atob(dateCreatedRoundedEncoded)
                        let rangeDatesObject = getAgGridDateRangeFilterForIncidentDateCreatedRoundedInterval(dateCreatedRoundedDecodedString)
                        if(zenGroupId && rangeDatesObject && zenGroup && zenGroup.friendlyName){
                            let startDateFilterString = rangeDatesObject.startDate
                            let endDateFilterString = rangeDatesObject.endDate
                            if(startDateFilterString && endDateFilterString){
                                let pathEncoded = fullDataIncidentFilterCriteriaURLSearchParams.pathEncoded
                                let parentPathEncoded = fullDataIncidentFilterCriteriaURLSearchParams.parentPathEncoded
                                let machineName = atob(machineEncoded)
                                //build filter to apply to grid
                                filterForNotification = true
                                saveFilterChanges = false //don't save filter changes for when we auto filter
                                this.props.setFullGridToggled && this.props.setFullGridToggled(false) //show old parent/child grid since thats how the service works for security alert
                                let filter = {}

                                filter["zenGroupDisplayName"] = {
                                    "values": [
                                        zenGroup.friendlyName
                                    ],
                                    "filterType": "set"
                                }
                                filter["dateCreatedRounded"] = {
                                    "dateFrom": startDateFilterString,
                                    "dateTo": endDateFilterString,
                                    "filterType": "date",
                                    "type": "inRange"
                                }
                                filter["machineName"] = {
                                    "filterType": "text",
                                    "type": "contains",
                                    "filter": machineName
                                }
                                if(pathEncoded){
                                    filter["pathEncoded"] = {
                                        "filterType": "text",
                                        "type": "contains",
                                        "filter": atob(pathEncoded)
                                    }
                                }
                                if(parentPathEncoded){
                                    filter["parentPathEncoded"] = {
                                        "filterType": "text",
                                        "type": "contains",
                                        "filter": atob(parentPathEncoded)
                                    }
                                }

                                //TODO: Take in a silent incident param in URL or just always filter for not silent incidents??
                                filter["whitelistAppliedId"] = {
                                    "filterType": "multi",
                                    "filterModels": [
                                        {"values": ["Not Excluded"], "filterType": "set"},
                                        {"values":["Not Silent"],"filterType":"set"}
                                    ]
                                }
                                //apply filter model
                                gridReadyParams.api.setFilterModel(filter);
                            }
                        }
                    }
                } catch (e) {}
            }
        }

        //the indexes are in the same order as they are in the column def for whitelistAppliedId, so whitelisted is first and silent is second. Default to show Not Whitelisted and Not Silent incidents
        if(!filterForNotification){
            let defaultFilterObject = {"whitelistAppliedId":{"filterType":"multi","filterModels":[{"values":["Not Excluded"],"filterType":"set"},{"values":["Not Silent"],"filterType":"set"}]}}
            onGridReadyHelper(gridReadyParams, "incidentsGridFilterState",defaultFilterObject);
        }


        this.gridApi = gridReadyParams.api;
        this.props.setGridApi(gridReadyParams.api);

        let functionToUse = fullGridColumnsEnabled ? incidentTimeSeriesFullListReactive : incidentTimeSeriesListReactive
        var dataSource = {
            getRows: async function (params) {
                try{
                    let start = params.request.startRow;
                    let end = params.request.endRow;
                    let count = end - start;
                    let page = Math.floor(start / count)
                    let singleConditionFilters = masterFilterHelper(params.request.filterModel, true)
                    let multiConditionFilters = serverSideFilterHelperHandleMultiConditionChecks(params.request.filterModel)
                    let sortModel = params.request.sortModel;
                    let sortModelForRequest = null;
                    if(sortModel && sortModel.length > 0){
                        try{ //extra precaution for array access on the sort model so it does not break
                            if(sortModel[0].colId && sortModel[0].sort){
                                sortModelForRequest = sortModel[0]
                            }
                        }
                        catch(error){
                            console.log("Error generating sort request")
                        }
                    }
                    let incidents = await functionToUse(count, page, sortModelForRequest, singleConditionFilters, multiConditionFilters)
                    let finalPage = true
                    //This logic mimics how we would check in the rest api for what to send for the finalPage in the response. Same logic is being used here so we can just return a flux from the
                    // endpoint instead of Mono with a Response object
                    if(incidents && incidents.length === count){
                        finalPage = false
                    }
                    let lastIdx = undefined
                    if (finalPage) {
                        lastIdx = (count * page) + incidents.length
                    }

                    params.api.deselectAll();

                    const success = (incidents.length !== 0);
                    if (success) {
                        params.api.hideOverlay() //clear any leftover no rows overlay
                        params.api.setGridOption("loading", false)
                        params.success({
                            rowData: incidents, rowCount: lastIdx
                        })
                    } else {
                        params.success({
                            rowData: incidents, rowCount: lastIdx
                        })
                        params.fail();
                    }
                }
                catch(error){
                    //console.log(error);
                    params.api.showNoRowsOverlay();
                    params.fail();
                }
            }
        }
        gridReadyParams.api.setGridOption("serverSideDatasource", dataSource);
        //gridReadyParams.api.sizeColumnsToFit()
    };

    detailCellRendererParams = (detailParams) => {

        let agentIdOfMaster = detailParams.node.data.agentId
        let agentNameOfMaster = detailParams.node.data.agentDisplayName
        let deletedValue = getIncidentDeletedValueForCell(detailParams)
        let initializeDeleteModalToPass = null
        if(deletedValue === "None"){
            initializeDeleteModalToPass = this.props.initializeDeleteModalForIconClick
        }
        //let machineNameForLocationLinkOfMaster = detailParams.node.data.machineNameForLocationLink
        let detailGridColumnDefs = [
            {
                field: "incidentDisplayName",
                headerName: `Response Name`,
                sortable: true,
                width: 415,
                editable: true,
                cellEditor: "customNameCellEditor",
                filter: 'agTextColumnFilter',
                filterParams: {
                    suppressSorting: true,
                    buttons: ["reset", "apply"],

                    filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                    maxNumConditions: 2,
                },
                valueFormatter: null,
                cellRenderer: (params) => {
                    return incidentNameCellRendererFrameworkForIncidentsGrid(params, this.props.initializeWhitelistModalForIconClick, this.props.initializeDetailsModalForIconClick,
                        this.props.initializeTurnSilentSettingToOnForIconClick, this.props.initializeTurnSilentSettingToOffForIconClick, "Response", initializeDeleteModalToPass)
                }
            },
            { field: "zenGroupId", hide: true, suppressColumnsToolPanel: true, lockVisible: true},
            {
                field: "rootCauseAnalysis", headerName: "Root Cause Analysis", width: 300,
                sortable: false,
                valueFormatter: function (params) {
                    if (params.node.data.rootCauseAnalysis) {
                        return params.node.data.rootCauseAnalysis
                    }
                    let path = params.node.data.path
                    if (path && params.node.data.incidentId && params.node.data.zenGroupId && params.node.data.uniqueProcessIdentifier !== null && params.node.data.uniqueProcessIdentifier !== undefined) {
                        checkIncidentHasRelatedProcessInjectionsAndCreationsReactive(params.node.data.incidentId, params.node.data.zenGroupId, params.node.data.uniqueProcessIdentifier, path).then(response => {
                            params.node.data.relatedProcessCreationExists = response.relatedProcessCreationExists
                            params.node.data.relatedProcessInjectionExists = response.relatedProcessInjectionExists
                            params.node.data.memoryFileExists = response.memoryFileExists
                            params.node.data.relatedUntrustedDLLExists = detailParams.node.data.untrustedModuleWasLoaded //make new variable so it won't appear in cell until query is finished
                            //Show the Related Processes Found text over Memory Download Available if either fields are true
                            if (response.relatedProcessCreationExists || response.relatedProcessInjectionExists) {
                                params.node.setDataValue("rootCauseAnalysis", "Related Processes Found")
                            } else {
                                //If we have memoryFileExists true then we can show some text, else show nothing
                                if(response.memoryFileExists){
                                    params.node.setDataValue("rootCauseAnalysis", "Memory Diff Download Available")
                                }
                                else if(params.node.data.relatedUntrustedDLLExists){
                                    params.node.setDataValue("rootCauseAnalysis", "Untrusted Modules Found")
                                }
                                else{
                                    params.node.setDataValue("rootCauseAnalysis", " ") //lets cell know not to call checkIncidentHasRelatedProcessInjectionsAndCreationsReactive again
                                }
                            }
                        }).catch(function (error) {
                            params.node.setDataValue("rootCauseAnalysis", " ") //lets cell know not to call checkIncidentHasRelatedProcessInjectionsAndCreationsReactive again
                        })
                        params.node.data.rootCauseAnalysis = params.node.data.zenGroupId
                        return params.node.data.zenGroupId
                    }
                },
                cellRenderer: function (params) {
                    let spinnerDiv = ""
                    let memoryFileDownloadIcon = ""
                    let processCreationsLinkDiv = ""
                    let processInjectionsLinkDiv = ""
                    let dllsDiv = ""
                    let path = params.node.data.path
                    if (path && params.node.data.zenGroupId && params.node.data.uniqueProcessIdentifier !== null && params.node.data.uniqueProcessIdentifier !== undefined) {
                        if (params.node.data.rootCauseAnalysis === params.node.data.zenGroupId) {
                            spinnerDiv = <FontAwesomeIcon
                                className="contain fa-pulse mr-1"
                                icon="fa-light fa-spinner"
                                size="lg"
                                name="relatedProcessesLoading"
                            />
                        } else {
                            spinnerDiv = ""
                        }
                        //Check if we should show Memory file download icon
                        if (params.node.data.memoryFileExists === true) {
                            memoryFileDownloadIcon =
                                <div className={"mb-1"}>
                                    <MuiIconButtonWithTooltip
                                        icon={ <FontAwesomeIcon
                                            className="object-contain"
                                            icon="fa-duotone fa-download"
                                            size="xs"
                                        />}
                                        tooltipTitle={"Click to download the Memory Diff File for this Extortion Response. Please contact support for more information about this file."}
                                        tooltipPlacement={"bottom-start"}
                                        onClick={() => {
                                            if(params.node.data.incidentId){
                                                getCCDiffFileReactive(params.node.data.incidentId).then(response => {
                                                    try{
                                                        let incidentName = params.node.data.incidentDisplayName
                                                        let bytes = base64ToArrayBuffer(response.data); // pass your byte response to this constructor
                                                        let blob = new Blob([bytes], {type: "application/octet-stream"});// change resultByte to bytes
                                                        //Add in local datetime string to filename down to the minutes, and this is in 24-hour time format
                                                        let today = new Date();
                                                        let date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
                                                        let time = today.getHours() + "-" + today.getMinutes();
                                                        let dateTime = date+'T'+time;
                                                        let link=document.createElement('a');
                                                        link.href=window.URL.createObjectURL(blob);
                                                        link.download=`${agentNameOfMaster}-${incidentName}-${dateTime}.ccdiff`;
                                                        link.click();
                                                    }
                                                    catch(error){
                                                        NotificationManager.error("Unexpected error making this request");
                                                    }
                                                }).catch(function (error) {
                                                    if(error.message){
                                                        NotificationManager.error(error.message);
                                                    }
                                                    else{
                                                        NotificationManager.error("Unexpected error making this request");
                                                    }
                                                })
                                            }
                                            else{
                                                NotificationManager.error("Unexpected error making this request");
                                            }
                                        }}
                                    />
                                </div>
                        }

                        //Links
                        if (params.node.data.relatedProcessCreationExists === true) {
                            processCreationsLinkDiv =
                                <Link to={{
                                    pathname: "/private/processCreations"
                                }} state={{
                                    uniqueProcessIdentifier: params.node.data.uniqueProcessIdentifier,
                                    zenGroupIdClicked: params.node.data.zenGroupId,
                                    childPath: path,
                                    agentIdClicked: params.node.data.agentId
                                }} className="">
                                    <div className={"mb-1"}>
                                        <MuiIconButtonWithTooltip
                                        icon={
                                            <FontAwesomeIcon
                                                className="object-contain"
                                                icon="fa-duotone fa-magnifying-glass-arrow-right"
                                                size="xs"
                                            />
                                        }
                                        tooltipTitle={"Click to view related process creations"}
                                        tooltipPlacement={"bottom-start"}
                                    />
                                    </div>
                                </Link>
                        }
                        if (params.node.data.relatedProcessInjectionExists === true) {
                            processInjectionsLinkDiv =
                                <Link to={{
                                    pathname: "/private/processInjections"
                                }} state={{
                                    uniqueProcessIdentifier: params.node.data.uniqueProcessIdentifier,
                                    zenGroupIdClicked: params.node.data.zenGroupId,
                                    agentIdClicked: params.node.data.agentId
                                }} className="">
                                    <div className={"mb-1"}>
                                        <MuiIconButtonWithTooltip
                                            icon={
                                                <FontAwesomeIcon
                                                    className="object-contain"
                                                    icon="fa-duotone fa-syringe"
                                                    size="xs"
                                                />
                                            }
                                            tooltipTitle={"Click to view related process injections"}
                                            tooltipPlacement={"bottom-start"}
                                        />
                                    </div>
                                </Link>
                        }
                        if (params.node.data.relatedUntrustedDLLExists === true) {
                            dllsDiv =
                                <div className={"mb-1"}>
                                    <MuiIconButtonWithTooltip
                                        icon={
                                            <FontAwesomeIcon
                                                className="object-contain"
                                                icon="fa-duotone fa-shield-xmark"
                                                size="xs"
                                            />
                                        }
                                        tooltipTitle={"Click to view the untrusted Modules for this response"}
                                        tooltipPlacement={"bottom-start"}
                                        onClick={() => {
                                            let baseUrl = "/private/relatedDLLs";
                                            let urlSearchParams = new URLSearchParams();
                                            urlSearchParams.append("uniqueProcessIdentifier", JSON.stringify(params.node.data.uniqueProcessIdentifier));
                                            urlSearchParams.append("agentId", JSON.stringify(params.node.data.agentId));
                                            urlSearchParams.append("zenGroupId", JSON.stringify(params.node.data.zenGroupId));

                                            /*
                                                Note that our service might not have populated ops database collection with the related dll, so check incident date collected time.
                                                The service runs every hour, but check if incident date is within the past 5 hours then set showAllTelemetry to true to give service
                                                time to populate ops db
                                             */
                                            let showAllTelemetry = false //Default to false so dlls page knows to send false for showAllTelemetry in req for query since dlls in ops db will not expire
                                            if(params.node.data.collected){
                                                try{
                                                    let dateCollected = new Date(params.node.data.collected)
                                                    let currentDate = new Date()
                                                    currentDate.setHours(currentDate.getHours() - 5)
                                                    if(dateCollected.getTime() >= currentDate.getTime()){
                                                        showAllTelemetry = true
                                                    }
                                                } catch (e) {}
                                            }

                                            urlSearchParams.append("showAllTelemetry", JSON.stringify(showAllTelemetry));


                                            let urlWithParams = `${baseUrl}?${urlSearchParams.toString()}`;
                                            let rememberMeEnabled = checkIsUsingRememberMe()
                                            if(rememberMeEnabled){
                                                //for now, if using rem me then open in new tab
                                                window.open(urlWithParams, "_blank", "noreferrer");
                                            }
                                            else{
                                                //for now, if not using rem me then we have to open in same tab
                                                window.open(urlWithParams, "_self", "noreferrer");
                                            }
                                        }}
                                    />
                                </div>
                        }
                    }

                    return (
                        <div className={"flex flex-nowrap items-center justify-start gap-x-0"}>
                            {spinnerDiv}
                            {memoryFileDownloadIcon}
                            {processCreationsLinkDiv}
                            {processInjectionsLinkDiv}
                            {dllsDiv}
                            {params.node.data.rootCauseAnalysis}
                        </div>
                    )
                }
            },
            { field: "status", headerName: "Status", width: 275,
                filter: 'agSetColumnFilter',
                filterParams: {
                    buttons: ["reset", "apply", "cancel"],
                    valueFormatter: function(params){
                        if(params.value === "WHITELISTED"){
                            return "Excluded"
                        }
                        else{
                            if(params.value === "AUTOMATICALLY_SUSPENDED"){
                                return "Automatically Suspended"
                            }
                            else if(params.value === "AUTOMATICALLY_HIDDEN"){
                                return "Automatically Hidden"
                            }
                            else if(params.value === "AUTOMATICALLY_BLOCKED"){
                                return "Automatically Blocked"
                            }
                            else{
                                return params.value
                            }
                        }
                    },
                    showTooltips: true
                },
                valueFormatter: function(params){
                    if(params.value === "WHITELISTED"){
                        return "Excluded"
                    }
                    else{
                        if(params.value === "AUTOMATICALLY_SUSPENDED"){
                            return "Automatically Suspended"
                        }
                        else if(params.value === "AUTOMATICALLY_HIDDEN"){
                            return "Automatically Hidden"
                        }
                        else if(params.value === "AUTOMATICALLY_BLOCKED"){
                            return "Automatically Blocked"
                        }
                        else{
                            return params.value
                        }
                    }
                },
                sortable: true
            },
            { field: "accessedFilePath", headerName: "Data Access Attempted", initialWidth: 450,
                filter: 'agTextColumnFilter',
                filterParams: {
                    suppressSorting: true,
                    buttons: ["reset", "apply"],
                    filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                    maxNumConditions: 2,
                },
                sortable: true,
                valueGetter: function (params) {
                    return handleCanaryPath(params.node.data.accessedFilePath)
                }
            },
            {
                //field that is set by us for getting either whitelist name or silent incident/response name(s)
                field: "hidingRule", headerName: "Hiding Rule", width : 430, sortable: false,
                valueFormatter: function(params){
                    if(params.node.data.hidingRule){
                        return params.node.data.hidingRule
                    }
                    if(params.node.data.whitelistAppliedId){
                        //call for whitelist name that is associated with whitelistAppliedId
                        let whitelistId = params.node.data.whitelistAppliedId
                        findBySingleWhitelistAppliedIdReactive(whitelistId).then(function(response){
                            if(response.whitelistName !== null){
                                params.node.setDataValue("hidingRule", response.whitelistName)
                            }
                            else{
                                params.node.setDataValue("hidingRule", "(The tailored behavior applied at the time of response was deleted)")
                            }
                            /*if(response.whitelist !== null){
                                params.node.data.tooltipData = response.whitelist
                            }*/
                        }).catch(function (error) {
                            params.node.setDataValue("hidingRule", " ")
                        })
                        params.node.data.hidingRule = whitelistId
                    }
                    else{
                        //else if incident was not whitelisted then check the silent field
                        if(params.node.data.silent){
                            let incidentId = params.node.data.incidentId
                            findSilentIncidentNamesForSingleIncidentIdReactive(incidentId).then(function(silentIncidentsList){
                                let listString = " "
                                let namesSet = new Set();
                                if(silentIncidentsList && silentIncidentsList.length > 0){
                                    silentIncidentsList.forEach(silentIncident => {
                                        if(silentIncident.silentIncidentDisplayName){
                                            namesSet.add(silentIncident.silentIncidentDisplayName)
                                        }
                                    })
                                    //convert set to array and join values together into one string to show in cell
                                    listString = Array.from(namesSet).join(' | ')
                                    //listString = Array.from(namesSet).join(', ')
                                }
                                params.node.setDataValue("hidingRule", listString)
                            }).catch(function (error) {
                                params.node.setDataValue("hidingRule", " ")
                            })
                            params.node.data.hidingRule = incidentId
                        }
                        else{
                            //don't show anything for incidents that aren't silent, but need to set dataValue so the spinner will stop in the cell renderer
                            params.node.setDataValue("hidingRule", " ")
                        }
                    }
                    return null
                },
                cellRenderer: function(params){
                    let spinnerDiv = ""
                    if(params.node.data.hidingRule === null || params.node.data.hidingRule === undefined || params.node.data.hidingRule === params.node.data.whitelistAppliedId ||
                        params.node.data.hidingRule === params.node.data.incidentId){
                        spinnerDiv =
                            <div>
                                <FontAwesomeIcon
                                    className="contain fa-pulse mr-1"
                                    icon="fa-light fa-spinner"
                                    size="lg"
                                    name="hidingRuleSpinner"
                                />
                                Loading
                            </div>
                    }
                    return(
                        <div className={"flex flex-nowrap items-center gap-x-2"}>
                            {spinnerDiv}
                            {params.node.data.hidingRule}
                        </div>
                    )
                },
            },
            { field: "incidentType", headerName: "File Access Trigger", width: 250,
                filter: 'agSetColumnFilter',
                filterParams: {
                    buttons: ["reset", "apply", "cancel"],
                    valueFormatter: (params) => {
                        if(params.value!=="(Select All)"){
                            return params.value.charAt(0).toUpperCase() + params.value.slice(1).toLowerCase();
                        }
                        else{
                            return params.value;
                        }
                    },
                    //File Attributes is for both SET_INFO and TIMESTAMP_OR_LEGAL_ATTRS, backend accounts for this in filter for this incidentType field
                    values: ["DELETE", "READ", "RENAME", fileAttributesString, "WRITE"],
                },
                sortable: true,
                valueFormatter:
                    function(params){
                        if(params.value) {
                            //if the incidentType is TIMESTAMP_OR_LEGAL_ATTRS or SET_INFO, return "File Attributes" for a better customer facing value, else return the value with first letter capitalized
                            switch(params.value) {
                                case "TIMESTAMP_OR_LEGAL_ATTRS":
                                    return fileAttributesString
                                case "SET_INFO":
                                    return fileAttributesString
                                default:
                                    //return first letter capitalized
                                    return params.value.charAt(0).toUpperCase() + params.value.slice(1).toLowerCase();
                            }
                        }
                    },
            },
            { field: "hasUntrustedRemoteThreads", headerName: "Untrusted Remote Threads", width: 325,
                filter: 'agSetColumnFilter',
                filterParams: {
                    buttons: ["reset", "apply", "cancel"],
                    valueFormatter: (params) => {
                        if(params.value!=="(Select All)"){
                            switch(params.value) {
                                case "UNKNOWN":
                                    return "Unknown"
                                case "TRUE":
                                    return "True"
                                case "FALSE":
                                    return "False"
                                default:
                                    return "";
                            }
                        }
                        else{
                            return params.value;
                        }
                    },
                    values: ['FALSE', 'TRUE', 'UNKNOWN'],
                    suppressSorting: true,
                },
                valueFormatter:
                    function (params) {
                        if(params.node.data.hasUntrustedRemoteThreads){
                            switch(params.node.data.hasUntrustedRemoteThreads) {
                                case "UNKNOWN":
                                    return "Unknown"
                                case "TRUE":
                                    return "True"
                                case "FALSE":
                                    return "False"
                                default:
                                    return "";
                            }
                        }else{
                            return ""
                        }
                    },
                sortable: true
            },
            { field: "hasModifiedMem", headerName: "Modified Memory", width: 230,
                filter: 'agSetColumnFilter',
                filterParams: {
                    buttons: ["reset", "apply", "cancel"],
                    valueFormatter: (params) => {
                        if(params.value!=="(Select All)"){
                            switch(params.value) {
                                case "UNKNOWN":
                                    return "Unknown"
                                case "TRUE":
                                    return "True"
                                case "FALSE":
                                    return "False"
                                default:
                                    return "";
                            }
                        }
                        else{
                            return params.value;
                        }
                    },
                    values: ['FALSE', 'TRUE', 'UNKNOWN'],
                    suppressSorting: true,
                },
                valueFormatter:
                    function (params) {
                        if(params.node.data.hasModifiedMem){
                            switch(params.node.data.hasModifiedMem) {
                                case "UNKNOWN":
                                    return "Unknown"
                                case "TRUE":
                                    return "True"
                                case "FALSE":
                                    return "False"
                                default:
                                    return "";
                            }
                        }else{
                            return ""
                        }
                    },
                sortable: true
            },
            { field: "hasNoTrustedCert", headerName: "No Trusted Cert", width: 230,
                filter: 'agSetColumnFilter',
                filterParams: {
                    buttons: ["reset", "apply", "cancel"],
                    valueFormatter: (params) => {
                        if(params.value!=="(Select All)"){
                            switch(params.value) {
                                case "UNKNOWN":
                                    return "Unknown"
                                case "TRUE":
                                    return "True"
                                case "FALSE":
                                    return "False"
                                default:
                                    return "";
                            }
                        }
                        else{
                            return params.value;
                        }
                    },
                    values: ['FALSE', 'TRUE', 'UNKNOWN'],
                    suppressSorting: true,
                },
                valueFormatter:
                    function (params) {
                        if(params.node.data.hasNoTrustedCert){
                            switch(params.node.data.hasNoTrustedCert) {
                                case "UNKNOWN":
                                    return "Unknown"
                                case "TRUE":
                                    return "True"
                                case "FALSE":
                                    return "False"
                                default:
                                    return "";
                            }
                        }else{
                            return ""
                        }
                    },
                cellRenderer: function(params){
                    let iconDiv = ""
                    if(params.node.data.windowsCode === 258){ //Timeout
                        iconDiv = <MuiIconButtonWithTooltip
                            icon={<TimerOffOutlinedIcon className={"cursor-pointer"}/>}
                            tooltipTitle={`Timeout occurred retrieving cert information from Windows`}
                            tooltipPlacement={"bottom-start"}
                        />
                    }
                    else if(params.node.data.windowsCode === 3221225527){ //Disconnect
                        iconDiv = <MuiIconButtonWithTooltip
                            icon={<VpnKeyOffOutlinedIcon className={"cursor-pointer"}/>}
                            tooltipTitle={`Disconnect occurred retrieving cert information from Windows. Reconnection was automatically restarted`}
                            tooltipPlacement={"bottom-start"}
                        />
                    }
                    return(
                        <div className={"flex flex-nowrap items-center gap-x-2"}>
                            {iconDiv}
                            {params.valueFormatted}
                        </div>
                    )
                },
                sortable: true
            },
            { field: "hasModifiedDllMem", headerName: "Modified Module Memory", width: 260,
                filter: 'agSetColumnFilter',
                filterParams: {
                    buttons: ["reset", "apply", "cancel"],
                    valueFormatter: (params) => {
                        if(params.value!=="(Select All)"){
                            switch(params.value) {
                                case "UNKNOWN":
                                    return "Unknown"
                                case "TRUE":
                                    return "True"
                                case "FALSE":
                                    return "False"
                                default:
                                    return "";
                            }
                        }
                        else{
                            return params.value;
                        }
                    },
                    values: ['FALSE', 'TRUE', 'UNKNOWN'],
                    suppressSorting: true,
                },
                valueFormatter:
                    function (params) {
                        if(params.node.data.hasModifiedDllMem){
                            switch(params.node.data.hasModifiedDllMem) {
                                case "UNKNOWN":
                                    return "Unknown"
                                case "TRUE":
                                    return "True"
                                case "FALSE":
                                    return "False"
                                default:
                                    return "";
                            }
                        }else{
                            return ""
                        }
                    },
                sortable: true
            },
            { field: "modifiedModuleIdentifier", headerName: "Modified Module Identifier", initialWidth: 600,
                filter: 'agTextColumnFilter',
                filterParams: {
                    suppressSorting: true,
                    buttons: ["reset", "apply"],
                    filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                    maxNumConditions: 2,
                },
                sortable: true
            },
            { field: "modifiedModulePath", headerName: "Modified Module Path", initialWidth: 600,
                filter: 'agTextColumnFilter',
                filterParams: {
                    suppressSorting: true,
                    buttons: ["reset", "apply"],
                    filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                    maxNumConditions: 2,
                },
                sortable: true,
                valueFormatter: function (params) {
                    if(params.node.data.modifiedModuleIdentifier === null || params.node.data.modifiedModuleIdentifier === undefined){
                        return " "
                    }
                    if (params.node.data.modifiedModulePath) {
                        return params.node.data.modifiedModulePath
                    }
                    if (params.node.data.incidentId) {
                        getDLLPathForDataIncidentReactive(params.node.data.incidentId).then(response => {
                            if (response.path !== null && response.path !== undefined) {
                                params.node.setDataValue("modifiedModulePath", response.path)
                            } else {
                                params.node.setDataValue("modifiedModulePath", " ")
                            }
                        }).catch(function (error) {
                            params.node.setDataValue("modifiedModulePath", " ") //lets cell know not to call getDLLPathForDataIncidentReactive again
                        })
                        params.node.data.modifiedModulePath = params.node.data.zenGroupId
                        return params.node.data.zenGroupId
                    }
                },
                cellRenderer: function (params) {
                    let spinnerDiv = ""
                    if (params.node.data.modifiedModuleIdentifier !== null && params.node.data.modifiedModuleIdentifier !== undefined) {
                        if (params.node.data.modifiedModulePath === params.node.data.zenGroupId) {
                            spinnerDiv = <FontAwesomeIcon
                                className="contain fa-pulse mr-1"
                                icon="fa-light fa-spinner"
                                size="lg"
                                name="dllPathLoading"
                            />
                        } else {
                            spinnerDiv = ""
                        }
                    }

                    return (
                        <div className={"flex flex-nowrap items-center justify-start gap-x-0"}>
                            {spinnerDiv}
                            {params.node.data.modifiedModulePath}
                        </div>
                    )
                }
            },
            { field: "modifiedModuleOriginalMemoryHash", headerName: "Modified Module Original Memory Hash", initialWidth: 400,
                filter: 'agTextColumnFilter',
                filterParams: {
                    suppressSorting: true,
                    buttons: ["reset", "apply"],
                    filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                    maxNumConditions: 2,
                },
                sortable: true
            },
            { field: "modifiedModuleCurrentMemoryHash", headerName: "Modified Module Current Memory Hash", initialWidth: 400,
                filter: 'agTextColumnFilter',
                filterParams: {
                    suppressSorting: true,
                    buttons: ["reset", "apply"],
                    filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                    maxNumConditions: 2,
                },
                sortable: true
            },
            { field: "certPublisherNames", headerName: "Cert Publisher Names List", hide: true, sortable: true, width: 500, suppressColumnsToolPanel: true,
                filter: 'agTextColumnFilter',
                filterParams: {
                    suppressSorting: true,
                    buttons: ["reset", "apply"],

                    filterOptions: ['contains'],
                    maxNumConditions: 1,
                }
            },
            { field: "username", headerName: "Username", initialWidth: 320,
                filter: 'agTextColumnFilter',
                filterParams: {
                    suppressSorting: true,
                    buttons: ["reset", "apply"],

                    filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                    maxNumConditions: 2,
                },
                sortable: true
            },
            { field: "uniqueProcessIdentifier.bootGuid", headerName: "Process Execution GUID", initialWidth: 375,
                filter: 'agTextColumnFilter',
                filterParams: {
                    suppressSorting: true,
                    buttons: ["reset", "apply"],

                    filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                    maxNumConditions: 2,
                },
                sortable: true,
                cellRenderer: function (params) {
                    return (
                        <div className={`flex flex-row items-center gap-x-1`}>
                            <div className={""}>
                                <MuiIconButtonWithTooltip
                                    icon={
                                        <FontAwesomeIcon
                                            className="object-contain"
                                            icon="fa-light fa-circle-info"
                                            size="xs"
                                        />
                                    }
                                    tooltipTitle={"The process execution guid is a unique identifier for the time period between boot and shutdown/restart. Pid reuse numbers are unique per boot guid."}
                                    tooltipPlacement={"bottom-start"}
                                />
                            </div>
                            {params.value}
                        </div>
                    )
                }
            },
            { field: "pid", headerName: "Pid", initialWidth: 150,
                filter: 'agNumberColumnFilter',
                filterParams: {
                    suppressSorting: true,
                    buttons: ["reset", "apply"],

                    filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual'],
                    maxNumConditions: 2,
                },
                sortable: true
            },
            { field: "uniqueProcessIdentifier.reuseCount", headerName: "Pid Reuse Number", initialWidth: 250,
                filter: 'agNumberColumnFilter',
                filterParams: {
                    suppressSorting: true,
                    buttons: ["reset", "apply"],

                    filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual'],
                    maxNumConditions: 2,
                },
                sortable: true
            },
            { field: "userSid", headerName: "User Sid", hide: true, sortable: true, initialWidth: 500, suppressColumnsToolPanel: true, lockVisible: true,
                filter: 'agTextColumnFilter',
                filterParams: {
                    suppressSorting: true,
                    buttons: ["reset", "apply"],

                    filterOptions: ['contains'],
                    maxNumConditions: 2,
                }
            },
            { field: "agentVersionFormatted", headerName: "Agent Version", width: 225,
                filter: 'agTextColumnFilter',
                filterParams: {
                    suppressSorting: true,
                    buttons: ["reset", "apply"],

                    filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                    maxNumConditions: 2,
                },
                sortable: true,
                valueFormatter: agentVersionFormatter,
                cellRenderer: function(params){
                    let spinnerDiv = ""
                    if(params.node.data.agentId === params.valueFormatted ){
                        spinnerDiv = <FontAwesomeIcon
                            className="contain fa-pulse"
                            icon="fa-light fa-spinner"
                            size="lg"
                            name="agentVersionLoading"
                        />
                    }else{
                        spinnerDiv = ""
                    }
                    return(
                        <div id ="fortooltip" className={"flex flex-nowrap items-center gap-x-2"}>
                            {spinnerDiv}
                            {params.valueFormatted}
                        </div>
                    )
                },
            },
            { field: "currentLatestAgentVersion", headerName: "Latest Agent Version", width: 275,
                filter: 'agTextColumnFilter',
                filterParams: {
                    suppressSorting: true,
                    buttons: ["reset", "apply"],

                    filterOptions: ['contains', 'notContains', 'equals', 'startsWith', 'endsWith'],
                    maxNumConditions: 2,
                },
                sortable: true,
            },
            { field: "created", headerName: "Created", width: 280,
                filter: 'agDateColumnFilter',
                filterParams:dateFilterParametersInHeaderSuppressSorting(2),
                sortable: true,
                valueFormatter: dateValueFormatter
            },
            { field: "collected", headerName: "Collected", width: 280,
                filter: 'agDateColumnFilter',
                filterParams:dateFilterParametersInHeaderSuppressSorting(2),
                sortable: true,
                valueFormatter: dateValueFormatter
            },
        ]
        return {
            detailGridOptions: {
                getRowId: (params) => {
                    return params.data.incidentId;
                },
                columnDefs: detailGridColumnDefs,
                defaultColDef: {
                    resizable: true,
                    filterParams: null,
                    headerClass:"border-0 border-b-0",
                    cellClass:"outline:none",
                    floatingFilter: true,
                    cellDataType: false //disable inferring cell data type automatically, can be overridden in individual colDef
                },
                suppressExcelExport: true,
                suppressCsvExport: true,
                enableCellTextSelection : true,
                components: {agDateInput: DTPicker, customNameCellEditor: CustomNameCellEditor},
                onCellEditingStopped: incidentPageCellEditingStopped,
                getContextMenuItems: this.getContextMenuItems
            },
            getDetailRowData: async (detailRowDataParams) => {
                let masterRowData = detailRowDataParams.node.data
                let detailRowData = []
                try{
                    detailRowData = await getDetailRowsForIncidentTimeSeriesReactive(masterRowData.agentId, masterRowData.zenGroupId, masterRowData.dateCreatedRounded,
                        masterRowData.pathEncoded, masterRowData.programArgumentsEncoded, masterRowData.parentPathEncoded, masterRowData.parentProgramArgumentsEncoded)
                } catch (e) {

                }
                if(!agentNameOfMaster){
                    //Need to call to api to get agent name if agentNameOfMaster does not have a value so we don't show blank cell in detail grid. This is edge case and only happens if they expand row before the
                    // agent name api call returns, then the detail grid doesn't get the update for agent name col.
                    try{
                        let agentNameObjects = await getAgentFriendlyNamesReactive([agentIdOfMaster])
                        if(agentNameObjects && agentNameObjects.length>0) {
                            if (agentNameObjects[0].name) {
                                agentNameOfMaster = agentNameObjects[0].name
                            }
                            /*
                            if (agentNameObjects[0].machineName) {
                                machineNameForLocationLinkOfMaster = agentNameObjects[0].machineName
                            }

                             */
                        }
                    } catch (e) {}
                }
                detailRowDataParams.successCallback(detailRowData)
            },
        }

    }

    render() {
        let fullGridColumnsEnabled = this.props.gridWithAllColumns

        return (
            <div className={"w-full h-full"} style={{minHeight: "400px"}}>
                <div id="incidentGrid" className="ag-theme-alpine rounded-md shadow h-full w-full">
                    <AgGridReact
                        columnMenu={"legacy"}
                        modules={[
                            ServerSideRowModelModule,
                            ColumnMenuModule,
                            ContextMenuModule,
                            ColumnsToolPanelModule,
                            SetFilterModule,
                            MultiFilterModule,
                            MasterDetailModule,
                            ClientSideRowModelModule,
                            AllCommunityModule
                        ]} //ClientSideRowModelModule is also needed for detail grid
                        defaultColDef={this.props.defaultColDef}
                        columnDefs={this.props.initialGridColumnDefs}
                        suppressOverlays={["noRows"]}
                        suppressExcelExport={true}
                        suppressCsvExport={true}
                        suppressMultiSort={true}
                        detailRowHeight={this.props.detailRowHeight}
                        keepDetailRows={true} //keeps detail rows
                        components={{agDateInput: DTPicker, customNameCellEditor: CustomNameCellEditor}}
                        rowModelType={'serverSide'}
                        maintainColumnOrder={true} //fixes issue where if you re-order/move column then click anywhere on the grid it reverts this change
                        masterDetail={!fullGridColumnsEnabled}
                        detailCellRendererParams={this.detailCellRendererParams}
                        onGridReady={this.onGridReady}
                        onCellEditingStopped={incidentPageCellEditingStopped}
                        rowSelection={this.props.rowSelection}
                        onSelectionChanged={() => {
                            const selectedRows = this.gridApi.getSelectedRows();
                            this.props.onClickRow && this.props.onClickRow(selectedRows);
                        }}
                        enableCellTextSelection={true}
                        ensureDomOrder={true}
                        onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                        tooltipShowDelay={0}
                        tooltipMouseTrack={true }
                        onFilterChanged={(params)=> {
                            if(saveFilterChanges) {
                                onFilterChangedHelper(params, 'incidentsGridFilterState', updateIncidentsGridFilterModelReactive);
                            }
                        }}
                        //columnState listeners
                        onSortChanged={this.onColumnStateChanged}
                        onColumnMoved={this.onColumnStateChanged}
                        onColumnVisible={this.onColumnStateChanged}
                        getContextMenuItems={this.getContextMenuItems}
                        sideBar={this.props.sideBar}
                    />
                </div>
            </div>
        );
    }
}

class DetailsGrid extends Component {
    constructor(props, onClickRow, filterVals, headers, data) {
        super(props);
    }
    onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns()
    };

    onGridReady = async (params) => {
        this.gridApi = params.api;
    }

    render() {
        return (
            <div className="mt-2">
                <div
                    id="myGrid"

                    className="ag-theme-alpine rounded-md shadow h-full w-full"
                >
                    <AgGridReact
                        columnMenu={"legacy"}
                        defaultColDef={{
                            resizable: true,
                            filterParams: null,
                            floatingFilter: false,
                            headerClass: "border-0 border-b-0",
                            cellClass: "outline:none",
                            enableCellChangeFlash: true,
                            autoHeight: false,
                            cellDataType: false //disable inferring cell data type automatically, can be overridden in individual colDef
                        }}
                        columnDefs={this.props.headers}
                        suppressExcelExport={true}
                        suppressCsvExport={true}
                        modules={[
                            AllCommunityModule,
                            ClientSideRowModelModule,
                            ColumnMenuModule,
                            ContextMenuModule
                        ]}
                        suppressMultiSort={true}
                        domLayout="autoHeight"
                        headerHeight={50}
                        enableBrowserTooltips={true}
                        rowData={this.props.data}
                        onFirstDataRendered={this.onFirstDataRendered}
                        rowSelection={this.props.rowSelection}
                        onGridReady={this.onGridReady}
                        enableCellTextSelection={true}
                        ensureDomOrder={true}
                    />
                </div>
            </div>
        );
    }
}
export function base64ToArrayBuffer(base64) {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}

export function getDateStringForAgGridFilter(millis, secondsToUse = null, roundMinutesDown=false){
    try{
        //Need to format the date filter string for ag grid. Have to also convert the date to user's saved timezone setting
        let timezone = decryptAndGetSessionVariable("timezone")
        if(timezone === null || timezone === undefined){
            timezone = "Europe/London" //default to london gmt time if timezone is null
        }
        let date = new Date(new Date(millis).toLocaleString('en-US', {timeZone: timezone}))
        let year = date.getFullYear()
        //Using formatDayOrMonthWithLeadingZero to fix issue found in ag grid v34.1.1 when you don't have 2 digits for day and month, we used to have 8 but now we need 08 for example
        let month = formatDayOrMonthWithLeadingZero(date.getMonth() + 1) //month starts at 0
        let day = formatDayOrMonthWithLeadingZero(date.getDate())
        let dateString = `${year}-${month}-${day}`
        let hour = date.getHours()
        let mins = date.getMinutes()
        if(roundMinutesDown){
            /*
                Round down to 10 min interval, intended for extortion response alerts only. This is needed because service notification event queryStartDateMillis could be Mon Dec 08 2025 13:05:35.891
                for example from the service, but the date created rounded in the incident itself would be 13:00:00 since it is rounded down to last 10 min interval. So the auto filter would not work since
                the rounded minutes is less than the filter minutes in this example. Rounding the minutes down for the start date auto filter will fix this
             */
            try{
                mins = mins - (mins % 10)
            } catch (e) {}
        }
        let seconds = 0 //dateCreatedRounded is set to 0 upon insertion, so we should set it to 0 here so the seconds don't go over
        //secondsToUse was implemented if it is desired to directly set the seconds to use for the filter, instead of it always being 0. The fullDataIncidentFilterCriteria auto filter inRange end date will use 59s instead of 0
        if(secondsToUse !== null && secondsToUse !== undefined){
            seconds = secondsToUse
        }
        let timeString = `${hour}:${mins}:${seconds}`

        return `${dateString}T${timeString}`
    } catch (e) {
        return null
    }
}

function getAgGridDateRangeFilterForIncidentDateCreatedRoundedInterval(millis){
    //The same as getDateStringForAgGridFilter, except this will return both the start and end date for the extortionResponseFullFilterCriteriaEncoded URL param auto filter.
    //It will take the start date and add 9 mins 59s and return both dates as strings formatted for ag grid.
    try{
        //Need to format the date filter string for ag grid. Have to also convert the date to user's saved timezone setting
        let timezone = decryptAndGetSessionVariable("timezone")
        if(timezone === null || timezone === undefined){
            timezone = "Europe/London" //default to london gmt time if timezone is null
        }
        //Format start date filter
        let dateCreatedRounded = new Date(new Date(millis).toLocaleString('en-US', {timeZone: timezone}))
        let startYear = dateCreatedRounded.getFullYear()
        let startMonth = formatDayOrMonthWithLeadingZero(dateCreatedRounded.getMonth() + 1)//month starts at 0
        let startDay = formatDayOrMonthWithLeadingZero(dateCreatedRounded.getDate())
        let startDateString = `${startYear}-${startMonth}-${startDay}`
        let startHour = dateCreatedRounded.getHours()
        let startMins = dateCreatedRounded.getMinutes()
        let startSeconds = 0 //dateCreatedRounded is set to 0 upon insertion, so we should set it to 0 here so the seconds don't go over
        let startTimeString = `${startHour}:${startMins}:${startSeconds}`
        let startTimeFilterString = `${startDateString}T${startTimeString}`

        //Format end date filter which is just adding 9 mins 59s
        dateCreatedRounded.setMinutes(dateCreatedRounded.getMinutes() + 10)
        dateCreatedRounded.setSeconds(dateCreatedRounded.getSeconds() - 1)

        let endYear = dateCreatedRounded.getFullYear()
        let endMonth = formatDayOrMonthWithLeadingZero(dateCreatedRounded.getMonth() + 1) //month starts at 0
        let endDay = formatDayOrMonthWithLeadingZero(dateCreatedRounded.getDate())
        let endDateString = `${endYear}-${endMonth}-${endDay}`
        let endHour = dateCreatedRounded.getHours()
        let endMins = dateCreatedRounded.getMinutes()
        let endSeconds = 59 //always use 59 seconds for end date filter
        let endTimeString = `${endHour}:${endMins}:${endSeconds}`
        let endTimeFilterString = `${endDateString}T${endTimeString}`

        return {
            "startDate": startTimeFilterString,
            "endDate": endTimeFilterString
        }

    } catch (e) {
        return null
    }
}

function getIncidentDeletedValueForCell(params){
    if(params.node.data.manualDeleteStatusSet){
        try {
            if(params.node.data.manualDeleteStatusSet.includes("Complete")){
                return "Manually Deleted Exe"
            }
            else if(params.node.data.manualDeleteStatusSet.includes("Queued")){
                return "Manual Delete Exe Queued"
            }
        } catch (e) {}
    }
    if(params.node.data.autoDeleteEnabledSet){
        try {
            if(params.node.data.autoDeleteEnabledSet.includes(true)){
                return "Auto Deleted Path"
            }
        } catch (e) {}
    }

    return "None"
}
function getIncidentDeletedValueForCellForFullGrid(params){
    if(params.node.data.manualDeleteStatus){
        try {
            if(params.node.data.manualDeleteStatus === "Complete"){
                return "Manually Deleted Exe"
            }
            else if(params.node.data.manualDeleteStatus === "Queued"){
                return "Manual Delete Exe Queued"
            }
        } catch (e) {}
    }
    if(params.node.data.autoDeleteEnabled){
        try {
            if(params.node.data.autoDeleteEnabled === true){
                return "Auto Deleted Path"
            }
        } catch (e) {}
    }

    return "None"
}



function handleCanaryPath(canaryPath){
    if(canaryPath === null || canaryPath === undefined || canaryPath.trim().length < 1){
        return ""
    }
    //Else it exists
    let lastSlashIndex  = canaryPath.lastIndexOf("\\")
    if (lastSlashIndex === -1) {
        return canaryPath;
    }
    //We found a slash, now get the substring after last index of the slash. Per agent team the canary will always be the last part of the path.
    let pathWithLastCanaryTrimmed = canaryPath.substring(0, lastSlashIndex) //Note that this trims off the last '\'. Just need (0, lastSlashIndex +1) to include it but we don't want to for comparison purposes. Make separate below in pathWithLastCanaryTrimmedWithEndingSlash
    let pathWithLastCanaryTrimmedWithEndingSlash = canaryPath.substring(0, lastSlashIndex + 1)

    let lastCanarySubstring = canaryPath.substring(lastSlashIndex + 1)
    if(lastCanarySubstring.trim().length < 1){
        return pathWithLastCanaryTrimmedWithEndingSlash //if something went wrong somehow then return canary path with everything after the last \ trimmed off
    }
    //Now extract canary name so we can compare to 1 directory up from original path to see if we need to remove that as well
    let lastCanaryName = lastCanarySubstring.split(".")[0] //everything before will be in position 0

    //get second to last '\' index to compare with lastCanaryName
    let secondToLastSlashIndex  = pathWithLastCanaryTrimmed.lastIndexOf("\\")
    if (secondToLastSlashIndex === -1) {
        return pathWithLastCanaryTrimmedWithEndingSlash; //if we don't have another '\' then just return pathWithLastCanaryTrimmed
    }
    let secondToLastCanaryName = pathWithLastCanaryTrimmed.substring(secondToLastSlashIndex + 1)
    if(secondToLastCanaryName.trim().length < 1){
        return pathWithLastCanaryTrimmedWithEndingSlash //if something went wrong somehow then return canary path with everything after the last \ trimmed off
    }

    /*
        Now compare lastCanaryName with secondToLastCanaryName.
           1. The lengths need to be equal to trim off secondToLastCanaryName from the path
           2. The secondToLastCanaryName string also needs to be valid hex alphabet of 0-9, A-F, H
        If 1. and 2. are not met then we can't trim off secondToLastCanaryName from path so return pathWithLastCanaryTrimmed
     */
    //Check for criteria 1.
    if(secondToLastCanaryName.length !== lastCanaryName.length){
        //1. criteria not met above, return pathWithLastCanaryTrimmed since we can't trim off secondToLastCanaryName from the original path
        return pathWithLastCanaryTrimmedWithEndingSlash
    }
    //Check for criteria 2.
    let valid = /^[0-9a-fA-FhH]+$/.test(secondToLastCanaryName); //check to make sure its 0-9, A-F, H

    if(valid){
        //Then trim off secondToLastCanaryName from original path
        return pathWithLastCanaryTrimmed.substring(0, secondToLastSlashIndex + 1)
    }
    else{
        //else not valid so don't trim secondToLastCanaryName off the original path
        return pathWithLastCanaryTrimmedWithEndingSlash
    }
}